// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/Images/RPM_CCM.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/Images/RPM_Solution.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  *{
    font-family: 'Montserrat', sans-serif;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    scroll-behavior: smooth;
  }

  *::-webkit-scrollbar {
    width: 3px;
    border-radius: 10px;
  }

  *::-webkit-scrollbar-track {
    background: #FFF;
  }

  *::-webkit-scrollbar-thumb {
    background-color: #555;
  }

  .error {
    position: 'absolute';
    color: red;
    font-size: 0.8rem;
    margin-top: 4px;
  }

  .blue-hr {
    background: #081D45;
    height: 1px
  }

  .white-hr {
    background: #EAEAEA;
    height: 1px
  }

  .admindashboardbody {
    overflow-x:hidden;
    overflow-y:hidden;
  }

  .rounded-card {
    border-radius: 25px;
  }

  .card-bordered {
    background-color: #0F2557;
    border-radius: 20px;
    box-shadow: -1px -3px 13px 0px rgba(0,0,0,0.44);
    color: #FFF
  }

  .card-bordered-01 {
    background-color: #FFF;
    border-radius: 10px;
    box-shadow: -1px -3px 13px 0px rgba(0,0,0,0.44);
    text-align: center;
    justify-content: center;  
  }

  .card-bordered-02 {
    background-color: #FFF;
    border-radius: 20px;
    box-shadow: -1px -3px 13px 0px rgba(0,0,0,0.44);
    text-align: center;
    justify-content: center;  
  }

  .activeRPMStatus {
    color: green;
    font-weight: 600;
  }


  /* Comment Bubble  */
  .bubble {
    box-sizing: border-box;
    float: left;
    width: auto;
    max-width: 80%;
    position: relative;
    clear: both;
    background-image: linear-gradient(#004aad, #004aad);
    border-radius: 10px;
    padding: 3px 15px;
    color: #000;
    word-wrap: break-word;
    margin-top: 10px;
  }

  .bubble-alt {
    float: left;
  }
  .bubble-alt:before {
    left: auto;
    right: -7px;
  }
  .bubble-alt:after {
    left: auto;
    right: -5px;
  }

  .bubble p {
    font-size: 14px;
    color: #FFF
  }

  /* Comment Bubble ends here */

  .alerts-section {
    background-color:#FFF;
    box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
    padding: 20px;
  }

  .alerts-section {
    max-height: 430px;
    overflow-y: auto;
  }

  .not-found-text {
    color: gray;
    font-size: 14px;
    font-weight: bold;
    width:100%
  }


  .form-label {
    font-size: 14px;
    color: #004aad;
    font-weight: bold;
  }

  /* ---------------------------------------------------------------
    Loader
  ----------------------------------------------------------------- */
  .loader-area {
    background-color: #FFF;
    height: 20%;
    width: 20%;
  }
  
  .loader {
    display: inline-block;
    position: absolute;
    width: 80px;
    height: 80px;
    left: 50%;
    top: 50%;
    margin: -40px 0 0 -40px;
  }

  .loader:after {
    content: " ";
    display: block;
    border-radius: 50%;
    width: 0;
    height: 0;
    margin: 8px;
    box-sizing: border-box;
    border: 32px solid #FFF;
    border-color: #999 transparent #004aad transparent;
    animation: lds-hourglass 1.2s infinite;
  }

  @keyframes lds-hourglass {
    0% {
      transform: rotate(0);
      animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    }
    50% {
      transform: rotate(900deg);
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    100% {
      transform: rotate(1800deg);
    }
  } 
  
  /*--------------------------------------------------------------
  # Top Bar
  --------------------------------------------------------------*/
  #topbar {
    background: #004aad;
    color: #D0D8DA;
    height: 40px;
    font-size: 14px;
    transition: all 0.5s;
    z-index: 996;
  }

  #topbar.topbar-scrolled {
    top: -60px;
  }

  #topbar .contact-info a {
    line-height: 1;
    color: #FFF;
    transition: 0.3s;
    letter-spacing: 1px;
  }

  #topbar .contact-info a:hover {
    color: #FFF;
    list-style: none;
    text-decoration: none;
  }

  #topbar .contact-info i {
    color: #FFF;
    font-size: 22px;
    padding-right: 4px;
    margin-left: 35px;
    line-height: 0;
  }
  #topbar .contact-info i:first-child {
    margin-left: 0;
  }

  #topbar .social-links a {
    color: #FFF;
    padding-left: 25px;
    display: inline-block;
    line-height: 1px;
    transition: 0.3s;
  }

  #topbar .social-links a:hover {
    color: #1977cc;
  }

  #topbar .social-links a:first-child {
    border-left: 0;
  }


  /*--------------------------------------------------------------
  # Header
  --------------------------------------------------------------*/
  #header {
    background: #fff;
    transition: all 0.5s;
    z-index: 997;
    padding: 5px 0;
    top: 40px;
    box-shadow: 0px 2px 15px rgba(25, 119, 204, 0.1);
  }

  #header.header-scrolled {
    top: 0;
  }

  .logoImg {
    width: 245px;
    height: 93px;
    margin: 0px auto;
  }

  .landingPageHeaderLogo {
    width:auto;
    height: 80px;
  }

  #header .logo {
    font-size: 30px;
    margin: 0;
    padding: 0;
    line-height: 1;
    font-weight: 700;
    letter-spacing: 0.5px;
    font-family: 'Open Sans', sans-serif;
  }

  #header .logo a {
    color: #004aad;
    text-decoration: none;
  }

  #header .logo img {
    max-height: 40px;
  }


  .male-tag {
    width: 70px;
    font-size: 12px;
    margin: 0 auto;
    background-color:#004aad !important;
    opacity: 0.5;
  }

  .assigned-tag {
    width: 70px;
    font-size: 12px;
    margin: 0 auto;
    background-color:#004aad !important;
  }

  .not-assigned-tag {
    width: 110px;
    font-size: 12px;
    margin: 0 auto;
    background-color:#385399 !important;
  }

  /**
  * Appointment Button *
  */
  .appointment-btn {
    margin-left: 25px;
    background: #004aad;
    color: #FFF;
    border-radius: 50px;
    padding: 8px 25px;
    white-space: nowrap;
    transition: 0.3s;
    font-size: 14px;
    display: inline-block;
    box-shadow: 5px 5px 12px #aaaaaa;
  }

  .appointment-btn:hover {
    background: #009ABB;
    color: #fff;
    text-decoration: none;
  }


  /*--------------------------------------------------------------
  # Featured Services
  --------------------------------------------------------------*/
  .featured-services {
    background: #004aad;
    margin: 40px;
    padding: 10px;
    border: 3px solid #EEE;
  }

  .icon-box {
    text-align: justify;
    padding: 10px
  }
  .icon-box-active {
    background: #FFF;
    height: 250px;
    border-radius: 10px;
    line-height: 25px;
    height: 330px;
    margin-top: -50px;
    margin-bottom: 20px;
    text-align: justify;
    padding: 10px;
  }

  .icon {
    color: #004aad;
    font-size: 30px;
    background: #DBDCD5;
    padding: 10px;
    border-radius: 25px;
    width:50px;
    margin: 15px
  }

  .icon-box-active .icon {
    color: #004aad;
    font-size: 30px;
    background: #DBDCD5;
    padding: 10px;
    border-radius: 50px;
    width:50px;
    margin: 15px
  }

  .icon-box-active .description {
    font-size: 14px;
  }

  .bordered-box {
    border-right: 4px solid #EEE;
  }


  /* -------------------------------------------------------------
  About Us 
  ---------------------------------------------------------------*/
  .about-us-section{
    width: 100%;
    height: 120%;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position:center
  }

  .about-us {
    margin-top:60px
  }

  .about-us-point {
    background: #004aad;
    padding: 10px;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    color: #FFF;
    width: 70%;
    text-align: center;
  }

  /*--------------------------------------------------------------
  # Services
  --------------------------------------------------------------*/
  .section {
    padding: 60px 0;
    overflow: hidden;
  }

  .section-bg {
    padding-bottom: 60px;
    background-color: #f1f7fd;
  }

  .section-title {
    text-align: center;
    padding-bottom: 30px;
  }

  .section-title h2 {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 20px;
    padding-bottom: 20px;
    position: relative;
    color: #2c4964;
  }

  .section-title h2::before {
    content: '';
    position: absolute;
    display: block;
    width: 120px;
    height: 1px;
    background: #ddd;
    bottom: 1px;
    left: calc(50% - 60px);
  }

  .section-title h2::after {
    content: '';
    position: absolute;
    display: block;
    width: 40px;
    height: 3px;
    background: #1977cc;
    bottom: 0;
    left: calc(50% - 20px);
  }

  .section-title p {
    margin-bottom: 0;
  }

  .services .icon-box {
    text-align: center;
    border: 1px solid #eee;
    padding: 80px 20px;
    transition: all ease-in-out 0.3s;
  }

  .services .icon-box .icon {
    margin: 0 auto;
    width: 64px;
    height: 64px;
    background: #FFF;
    border-radius: 5px;
    transition: all .3s ease-out 0s;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    transform-style: preserve-3d;
  }

  .services .icon-box .icon img {
    color: #fff;
    height: 100px;
    width: 100px;
  }

  .services .icon-box h4 {
    font-weight: 700;
    margin-bottom: 15px;
    font-size: 18px;
  }

  .services .icon-box h4 a {
    color: #2c4964;
  }

  .services .icon-box p {
    line-height: 24px;
    font-size: 14px;
    margin-bottom: 0;
  }

  .services .icon-box:hover {
    background: #009ABB;
    border-color: #AABEC6;
  }

  .services .icon-box:hover .icon {
    background: #fff;
  }

  .services .icon-box:hover .icon i {
    color: #004aad;
  }

  .services .icon-box:hover .icon::before {
    background: #3291e6;
  }

  .services .icon-box:hover h4 a, .services .icon-box:hover p {
    color: #fff;
  }

  /* ------------------------------------------------------------
  RPM Devices Section
  ----------------------------------------------------------------*/

  .rpm-card-images {
    width: 80px;
    height: 80px;
    margin: 20px 20px;
    background: #DBDCD5;
    padding: 17px;
    border-radius: 50px;
  }

  .rpm-devices-card-01 {
    background: #004aad;
    box-shadow: 0 0 5px 5px rgba(0,0,0, 0.1);
  }

  .rpm-devices-card-02 {
    background: #FFF;
    box-shadow: 0 0 5px 5px rgba(0,0,0, 0.1);
  }
  /* ------------------------------------------------------------
  Telemedine
  ---------------------------------------------------------------*/
  .telemedicine-section{
    padding: 30px
  }

  .telemedicine-heading {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: left;
    color: #2c4964;
  } 

  .telemedine-subheading{
    font-size: 24px;
    font-weight: bold;
    color: #004aad
  }

  .telemedine-img {
    width: 440px; 
    height:auto;
    align-self: center;
    margin-top: -90px;
    margin-left: 20px;

  }

  /* ------------------------------------------------------------
  How it works
  ---------------------------------------------------------------*/

  .how-it-works-icon {
    width: 50px;
    height: auto;
    margin: 10px;
    background-color: #DBDCD5;
    border-radius: 50px;
    padding: 5px
  }

  .how-it-works-card-01 {
    background-color: #004aad;
    color: #FFF;
    padding: 15px;
    border-radius: 25px;
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);

  }


  .how-it-works-card-04 {
    background-color: #004aad;
    color: #FFF;
    padding: 15px;
    border-radius: 25px;
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  }


  /*--------------------------------------------------------------
  # Appointments
  --------------------------------------------------------------*/
  .appointment .php-email-form {
    width: 100%;
  }

  .appointment .php-email-form .form-group {
    padding-bottom: 8px;
  }


  .appointment .php-email-form input, .appointment .php-email-form textarea, .appointment .php-email-form select {
    border-radius: 0;
    box-shadow: none;
    font-size: 14px;
    padding: 5px !important;
  }

  .appointment .php-email-form input:focus, .appointment .php-email-form textarea:focus, .appointment .php-email-form select:focus {
    border-color: #000 !important;
  }

  .appointment .php-email-form input, .appointment .php-email-form select {
    height: 44px;
  }

  .appointment .php-email-form textarea {
    padding: 10px 12px;
  }

  .appointment .php-email-form button[type="submit"] {
    background: #004aad;
    border: 0;
    padding: 10px 35px;
    color: #fff;
    transition: 0.4s;
    border-radius: 50px;
  }

  .appointment .php-email-form button[type="submit"]:hover {
    background: #004aad;
  }

  /************************************ Contact Map ******************************** */
  .mapouter {
    position:relative;
    text-align:right;
    width:100%;
    height:363px;
  }

  .gmap_canvas {
    overflow:hidden;
    background:none!important;
    width:100%;
    height:363px;
  }

  .gmap_iframe {
    height:363px!important;
  }

  /*--------------------------------------------------------------
  # Contact
  --------------------------------------------------------------*/
  .contact .info {
    width: 100%;
    background: #fff;
  }

  .contact .info img {
    width: 30px;
    height: 30px;
    float: left;
    width: 44px;
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease-in-out;
  }

  .contact .info h4 {
    padding: 0 0 0 60px;
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 5px;
    color: #2c4964;
  }

  .contact .info p {
    padding: 0 0 0 60px;
    margin-bottom: 0;
    font-size: 14px;
    color: #4b7dab;
  }

  .contact .info .email, .contact .info .phone {
    margin-top: 40px;
  }

  .contact .info .email:hover i, .contact .info .address:hover i, .contact .info .phone:hover i {
    background: #3fbbc0;
    color: #fff;
  }

  .contact .php-email-form {
    width: 100%;
    background: #fff;
  }

  .contact .php-email-form .form-group {
    padding-bottom: 8px;
  }

  .contact .php-email-form input, .contact .php-email-form textarea {
    border-radius: 0;
    box-shadow: none;
    font-size: 14px;
  }

  .contact .php-email-form input {
    height: 44px;
  }

  .contact .php-email-form textarea {
    padding: 10px 12px;
  }

  .contact .php-email-form button[type="submit"] {
    background: #004aad;
    border: 0;
    padding: 10px 35px;
    color: #fff;
    transition: 0.4s;
    border-radius: 50px;
  }

  .contact .php-email-form button[type="submit"]:hover {
    background:#3fbbc0;
  }

  @keyframes animate-loading {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }


  /*--------------------------------------------------------------
  # Footer
  --------------------------------------------------------------*/

  #footer .footer-top {
    background: #004aad;
    padding: 60px 0 30px 0;
    color: #FFF
  }

  #footer .footer-top .footer-info {
    margin-bottom: 30px;
  }

  #footer .footer-top .footer-info h3 {
    font-size: 24px;
    margin: 0 0 20px 0;
    padding: 2px 0 2px 0;
    line-height: 1;
    font-weight: 700;
  }

  #footer .footer-top .footer-info p {
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 0;
  }

  #footer .footer-top .social-links a {
    font-size: 18px;
    display: inline-block;
    background: #D0D8DA;
    color: #09425A;
    line-height: 1;
    padding: 8px 0;
    margin-right: 4px;
    border-radius: 4px;
    text-align: center;
    width: 36px;
    height: 36px;
    transition: 0.3s;
  }

  #footer .footer-top .social-links a:hover {
    background: #65c9cd;
    text-decoration: none;
  }

  #footer .footer-top h4 {
    font-size: 16px;
    font-weight: 600;
    position: relative;
    padding-bottom: 12px;
  }

  #footer .footer-top .footer-links {
    margin-bottom: 30px;
  }

  #footer .footer-top .footer-links ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  #footer .footer-top .footer-links ul i {
    padding-right: 2px;
    color: #FFF;
    font-size: 18px;
    line-height: 1;
  }

  #footer .footer-top .footer-links ul li {
    padding: 10px;
    display: flex;
    align-items: center;
  }

  #footer .footer-top .footer-links ul li:first-child {
    padding-top: 0;
  }

  #footer .footer-top .footer-links ul a {
    color: #FFF;
    transition: 0.3s;
    display: inline-block;
    line-height: 1;
  }

  #footer .footer-top .footer-links ul a:hover {
    color: #3fbbc0;
  }

  #footer .footer-top .footer-newsletter form {
    margin-top: 30px;
    background: #fff;
    padding: 6px 10px;
    position: relative;
    border: 1px solid #d5d5d5;
    border-radius: 4px;
  }

  #footer .footer-top .footer-newsletter form input[type="email"] {
    border: 0;
    padding: 4px;
    width: calc(100% - 110px);
  }

  #footer .footer-top .footer-newsletter form input[type="submit"] {
    position: absolute;
    top: -1px;
    right: -1px;
    bottom: -1px;
    border: 0;
    background: none;
    font-size: 16px;
    padding: 0 20px;
    background: #1977cc;
    color: #fff;
    transition: 0.3s;
    border-radius: 0 4px 4px 0;
  }

  #footer .footer-top .footer-newsletter form input[type="submit"]:hover {
    background: #65c9cd;
  }

  #footer .copyright {
    text-align: center;
    padding-top: 30px;
  }

  #footer .credits {
    padding-top: 10px;
    text-align: center;
    font-size: 13px;
  }

  /**********************************Landing Page Ends Here ***********************************/


  /**********************************Admin Dashboard Starts Here ***********************************/

  /* Sidebar */
  .sidebar {
    position: fixed;
    height: 100%;
    width: 280px;
    background-color: #0E194F;
    transition: all 0.5s ease;
    overflow-y: auto;
  }

  .sidebar.active{
    width: 60px;
    transition: all 0.5s ease;
  }

  .sidebar .logo-details {
    height: 80px;
    display: flex;
    align-items: center;
  }

  .sidebar .logo-details i {
    font-size: 24px;
    color: #FEFFFF;
    min-width: 50px;
    text-align: center;
    margin-top: 20px;
  }

  .sidebar .logo-details .logo_name{
    font-size: 22px;
    font-weight: 500;
    color: #CCCCCC;
    margin-top: 20px;
  }

  .sidebar .nav-links li {
    height:50px;
    width: 100%;
    list-style: none;
  }

  .sidebar .nav-links li a {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    text-decoration: none;
    transition: all 0.4s ease;
  }

  .sidebar .nav-links li a i {
    min-width: 40px;
    text-align: center;
    margin: 15px;
    padding: 6px;
  }

  .sidebar .nav-links li a .link_name{
    color: #3A3A3F;
    font-size: 14px;
    text-transform: capitalize;
  }

  .sidebar .nav-links li a .link_name{
    color: #FEFFFF; 
  }

  .link-name-active {
    background-color: #212A64;
    font-weight: bold;
    letter-spacing: 1px;
  }

  .sidebarBtn {
    cursor: pointer;
  }

  /* Home - Section CSS */
  .home-section {
    background: #FFF;
    position: relative;
    min-height: 100vh;
    width: calc(100% - 290px);
    left: 290px;
    transition: all 0.5s ease;
  }

  .sidebar.active ~ .home-section{
    width: calc(100% - 60px);
    left: 60px;
  }

  .home-section nav{
    width: 100%;
    height: 50px;
    background: #FFF;
    padding: 0 10px;
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
    transition: all 0.4s ease;
  }

  .sidebar.active ~ .home-section nav {
    width: 100%;
  }

  .sidebar-button {
    display: flex;
    align-items: center;
    font-size: 24px;
    font-weight: 500;
  }

  .sidebar-button i{
    font-size: 35px;
    margin-right: 10px;
  }


  .profile-details img{
    height: 50px;
    width: 55px;
    border-radius: 25px;
  }

  .profile-details .admin-name{
    font-size: 15px;
    font-weight: 500;
    color: dodgerblue;
    margin: 0 10px;
    white-space: nowrap;
  }

  .navbar-top {
    margin-bottom: 10px;
  }

  .notification-dropdown {
    margin-left: 10px;
    margin-right: 20px;
  }

  .admin-topbar-dropdown {
    width: 70px !important;
    margin: 10px;
  }

  .admin-topbar-notification-dropdown {
    width: 550px !important;
    max-height: 430px;
    overflow-y: auto;
    overflow-x:hidden;
  }

  .notification-text {
    font-size:12px;
    text-decoration: none;
    background-color: #CCC;
    padding: 10px;
  }

  .notification-text p {
    color: #222;
  }

  .drop-down-item-active:hover {
    background-color: #F1F1F1;
  }

  .drop-down-item-active:active{
    background-color: #F1F1F1
  }


  .searchArea {
    /* background-color: #6bd0f1; */
    background-color: #eae2b7;                
  }


  /* Home Content */
  .home-section .home-content {
    position: relative;
  }

  .home-content .overview-boxes {
    display: flex;
    width: 100%;
    justify-content: space-around;
    padding: 0 5px
  }

  .form-control {
    font-size: 14px;
    background-color: #FFF;
  }

  .form-control:focus {
    outline: none;
    border: 3px solid #004aad;
  }


  .home-content .overview-boxes .box{
    display: flex;
    align-items: center;
    padding: 15px 14px;
    justify-content: center;
    border-radius: 12px;
    width: calc(100% / 4 - 15px);
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    border-bottom: 3px solid #0E194F;
  }

  .home-content .overview-boxes .box0{
    background-image: linear-gradient(#1E3B70, #29539B);
  }

  .home-content .overview-boxes .box1{
    background-image: linear-gradient(#0ba360 , #3cba92);
  }

  .home-content .overview-boxes .box2{
    background-image: linear-gradient(#06beb6 , #48b1bf);
  }

  .home-content .overview-boxes .box3{
    background-image: linear-gradient(#F5515F , #A1051D);
  }

  .home-content .overview-boxes .staff-box0{
    background-image: linear-gradient(#061c27 , #023047);
  }

  .home-content .overview-boxes .staff-box1{
    background-image: linear-gradient(#a37e21 , #FFB703);
  }

  .home-content .overview-boxes .staff-box2{
    background-image: linear-gradient(#2d525c , #219EBC);
  }



  .home-content .overview-boxes .box_topic {
    font-size: 20px;
    font-weight: 500;
    color: #222
  }

  .home-content .overview-boxes .box_topic:hover {
    text-decoration: none;
  }

  .home-content .overview-boxes .number {
    font-size: 30px;
    font-weight: 900;
    display: inline-block;
    color: #0E194F;
    font-family:sans-serif;
  }


  .overview-boxes .indicator {
    display: flex;
    align-items: center;
    margin-top: 15px
  }


  .overview-boxes .indicator i{
    height: 20px;
    width: 20px;
    background: #8FDACB;
    color: #FFF;
    border-radius: 50%;
    font-size: 20px;
    margin-right: 5px;
  }

  .overview-boxes .indicator i.down{
    background: #e47474;
  }

  .overview-boxes .indicator .text{
    font-size: 12px;
    color: #222
  }

  .overview-boxes .box .cart {
    font-size: 32px;
    font-weight: 500;
    height:70px;
    width: 70px; 
    color: #FFF;
    line-height: 50px;
    text-align: center;
    border-radius: 12px;
  }



  /* Dashboard Cards */
  .rpm-devices-card {
    background: #FFF;
    border-radius: 12px;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
  }

  /* table classes */
  table {
    border:1px solid #D3D3D3;
    border-collapse: collapse;
    table-layout: auto;
  }

  table tr td{
    text-align: center;
    justify-content: center;
    padding: 3px 0px !important;
    margin: 0 !important;
  }

  th {
    background-color: #EAEAEA;
    color: #000;
    letter-spacing: 1px;    
  }

  tr {
    color: #444;
    font-size: 14px;
  }
  /*--------------------------------------------------------------
  # Admin Login Form
  --------------------------------------------------------------*/

  .login-section {
    position: relative;
    background: #ffffff;
    height:100vh;
    overflow-y: hidden;
    overflow-x: hidden;
  }

  .login-illustration {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: left center;
    pointer-events: none;
    -webkit-user-select: none;
            user-select: none;
  }

  .login-section > .container {
    position: relative;
  }

  @media (max-width: 991px) {
    .login-section .content {
      width: 55%;
    }
  }

  @media (max-width: 767px) {
    .login-section {
      background: #0c41a6;
      height: auto;
      min-height: 100vh;
      overflow-y: auto;
    }

    .login-illustration {
      display: none;
    }

    .login-section .content {
      width: auto;
      float: none;
      margin: 24px 0;
    }
  }

  .content {
    margin: 5%;
    background: #FAFAFA;
    border-radius: 10px;
    padding: 0.5rem;
    box-shadow: 0 0 5px 5px rgba(0,0,0, .25);
    width: 35%;
    float: right;
    opacity: 0.9;
  }

  .form-control {
    outline: none;
    box-shadow: none;
    border-color: #D3D3D3;
  }

  .forgot-password-link {
    color: #385399;
    font-size: 12px;
    margin-top: -4px;
    float: right;
    cursor: pointer;
    margin: 5px;
    font-weight: 500;
  }

  .forgot-password-link:hover {
    text-decoration: none;
  }


  /* CSS */
  .submit-btn {
    background-color: #23408e;
    color: #FFF;
    padding: 7px;
    border-radius: 5px;
    border: none !important;
    box-shadow: rgba(0, 0, 0, 0.1) 0 2px 4px;
    margin-bottom: 20px;
    transition: all .4s;
    width: 140px;
    display: block;
  }

  .submit-btn:hover{
    color: #fff;
  }

  .reset-btn {
    background-color: #004aad;
    color: #FFF;
    padding: 5px;
    border-radius: 5px;
    border: none !important;
    box-shadow: rgba(0, 0, 0, 0.1) 0 2px 4px;
    margin-bottom: 20px;
    transition: all .4s;
    min-width: 60px;
  }

  .row-class {
    float: right
  }

  /* -----------------------------Doctor Profile-------------------------- */
  .profile-card-img {
    /* border-radius: 50%; */
    display: table;
    margin: 0 auto;
    width: 40%;
    /* border: 2px solid #222; */
    padding: 5px

  } 

  .card-inner-margin {
    padding: 20px
  }


  .profile-name {
    font-size: 16px;
    margin-top: 5%;
    font-weight: bold;
    text-align: center;
    color: #081D45;
  }

  .patient-profile-name {
    font-size: 14px;
    margin-top: 5%;
    text-align: center;
    color: #081D45;
    text-transform: uppercase;
  }

  .patient-email {
    color: gray;
    font-size: 14px;
    text-align: center;
    margin-top: -10px; 
  }

  .doctor-specilizations {
    color: gray;
    font-size: 14px;
    letter-spacing: 2px;
    text-align: center;
  }

  .profile-label {
    color: #010101;
    font-size: 14px;
    font-weight: 600;
  }

  .profile-value-text {
    color: #333;
    margin-top: 5px;
    font-size: 15px;
  }

  .no-record-found-img {
    width: 100px;
    height: 100px;
    padding: 10px;
    margin-left: 45%;
  }

  .dropdown-menu {
    width: 16%;
    margin-left: 15px;
  }

  .jumbotron-blur-img {
    background-color: #004aad;
    opacity: 1;
  }

  .profile-img {
    height: 180px;
    width: 180px;
    border-radius: 50%;
    vertical-align: middle;
    border: 3px solid #004aad;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    
  }

  .profile-value-bottom-border {
    letter-spacing: 1px;
    border-bottom: 4px solid #004aad;
    margin: 3px;
    padding: 5px
  }

  .patient-profile-card-img {
    width: 80px;
    border-radius: 50%;
  }

  .patient-profile-card-img {
    border: 3px solid gray;
    padding: 5px
  }

  .patient-profile-col-heading {
    background-color: #d9dadb;
    color: #000;
    padding: 10px;
    border-radius: 5px;
    font-size: 12px;
    font-weight: 600;
  }

  .patient-profile-card-text{
    font-size: 14px;
  }

  .old-history-span-tag {
    color: dodgerblue;
    font-size: 12px;
  }

  /* Pagination */
  .page-item.active .page-link {
    background-color: #004aad;
    border-color: #D3D3D3;
  }

  .page-link {
    color: #000
  }

  .input-group {
    width: 90%;
    margin-right: 35%;
  }


  .list-box-header {
    margin-top: -5px;
    margin-bottom: 10px;
  }

  .header-group {
    flex-direction: row;
    justify-content:flex-end;
  }

  .add-staff-btn {
    background-color: #23408e;
    color: #FFF;
    font-size: 14px;
    padding: 10px;
    border-radius: 25px;
    border: none;
    float: left;
    transition: all 0.5s ease;
  }

  .add-staff-btn:hover {
    text-decoration: none;
    color: #F8C113
  } 

  .patient-profile-data-div {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    background-color: #23408e;
    box-shadow: 0px 0px 15px -10px #000000;
    color: #FFF;
    border-radius: 5px;
  }

  .check-icon {
    color: #fff;
  }

  .systolic-image {
    width: 50px;
    height: 50px
  }

  .navbar {
    padding: 0px;
    margin: 0px;
  }

  .navbar ul {
    margin: 0;
    padding: 0;
    display: flex;
    list-style: none;
    
  }

  .navbar li {
    position: relative;
  }

  .navbar > ul > li {
    position: relative;
    white-space: nowrap;
    padding: 8px 0 8px 40px;
    
  }

  .navbar a, .navbar a:focus {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    color: #2c4964;
    white-space: nowrap;
    transition: 0.3s;
    border-bottom: 2px solid #fff;
    padding: 5px 2px;
  }

  .navbar a i, .navbar a:focus i {
    font-size: 12px;
    line-height: 0;
    margin-left: 5px;
  }

  .navbar a:hover, .navbar .active, .navbar .active:focus, .navbar li:hover > a {
    color: #1977cc; 
  }


  /**
  * Mobile Navigation 
  */
  .mobile-nav-toggle {
    color: #2c4964;
    font-size: 28px;
    cursor: pointer;
    display: none;
    line-height: 0;
    transition: 0.5s;
  }

  .mobile-nav-toggle.bi-x {
    color: #fff;
  }



  @media (max-width: 991px) {
    .mobile-nav-toggle {
      display: block;
    }
    .navbar ul {
      display: none;
    }
  }


  .navbar-mobile {
    position: fixed;
    overflow: hidden;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: rgba(28, 47, 65, 0.9);
    transition: 0.3s;
    z-index: 999;
  }

  .navbar-mobile .mobile-nav-toggle {
    position: absolute;
    top: 15px;
    right: 15px;
  }

  .navbar-mobile ul {
    display: block;
    position: absolute;
    top: 55px;
    right: 15px;
    bottom: 15px;
    left: 15px;
    padding: 10px 0;
    background-color: #fff;
    overflow-y: auto;
    transition: 0.3s;
  }

  .navbar-mobile > ul > li {
    padding: 0;
  }

  .navbar-mobile a {
    padding: 10px 20px;
    font-size: 15px;
    color: #2c4964;
    border: none;
  }

  .navbar-mobile a:hover, .navbar-mobile .active, .navbar-mobile li:hover > a {
    color: #3fbbc0;
  }

  .navbar-mobile .getstarted {
    margin: 15px;
  }

  /*--------------------------------------------------------------
  # Home Section
  --------------------------------------------------------------*/
  #home {
    width: 100%;
    height: 100vh;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) top center;
    background-size: cover;
    margin-bottom: -100px;
  }

  #home .container {
    position: relative;
  }

  #home h1 {
    margin-top: 70px;
    font-size: 44px;
    font-weight: 700;
    line-height: 56px;
    text-transform: uppercase;
    color: #007C92;
  }

  #home h2 {
    color: #2c4964;
    margin: 10px 0 0 0;
    font-size: 18px;
    margin-top: 40px;
    word-spacing: 2px;
  }

  /* HR & DR Reports */
  .reportsHeading {
    background-color: #004aad;
    color: white;
    padding: 3px;
    border-radius: 50px;
    width: 40px;
    text-align: center;
  }

  .report-label{
    font-size: 14px;
    color: #222;
  }

  .spentTime {
    background-color: #004aad;
    font-size: 12px;
    color: #FFF;
    text-transform: uppercase;
    padding: 6px;
    border-radius: 5px
  }

  .total-time-spent {
    margin-left: 7px;
    font-weight: bold;
    letter-spacing: 1px;
    padding-top: 15px;
  }

  .graph-card {
    box-shadow: 0px 0px 15px -10px #000000;
    border-radius: 10px;
  }

  .row-display {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .row-display-secondary {
    display: flex;
    flex-direction: row; 
    border-radius: 5px;
  }

  .telemetary-patient-row{
    background-color: #d9dadb;
    color: gray;
    font-size: 13px;
    padding: 4px 0px;
    border-radius: 10px;
    letter-spacing: 1px;
  }

  .form-check-input {
    font-size: 16px;
  }

  .newUserGender>input {
    margin-top: 15px;
  }

  .newUserGender>label{
    margin: 10px;
    font-size: 18px;
    color: #555;
  }

  .select-input-type {
    background-color: #FFF;
    color: #000;
    height: 35px;
    font-size: 14px;
    width: 140px;
  }

  .select-input-type:focus {
    outline: none;
    box-shadow: none;
    border-color: #D3D3D3;
  }

  .telemetary-card {
    background: #FFF;
    box-shadow: 0 0 5px 5px rgba(0,0,0, 0.1);
    margin: 15px 5px;
    padding: 15px;
    border-radius: 15px;
  }

  .logs-card {
    /* background-color: #CCCCCC; */
    border-radius: 10px;
    padding: 10px;
    color: #FFF;
    max-height: 760px;
    overflow-y: auto;
  }

  .patient-logs-card {
    background: #F5FAFA;
    border-radius: 5px;
    padding: 7px;
    color: #111;
    max-height: 250px;
    overflow-y: auto;
  }

  .link {
    text-decoration: none !important; 
    font-size: 14px;
    color: #004aad;
    font-weight: bold;
  }

  .graphWrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .accordion {
    font-size: 14px;
    background-color: #F2F2F2;
    color: #000;
    padding: 5px;
    width: 140px;
    border-radius: 20px; 
    text-align: center;
    height: 30px;
    font-weight: bold
  }

  .accordion:focus {
    border: none;
    outline: none;
  }

  
  .accordion i {
    font-size: 14px;
    float:right;
    margin-top: 3px;
    font-weight: bold;
  }

  .panel {
    margin-top: 12px;
  }

  .notes-header {
    background-color: #fff;
    padding: 8px;
    border-radius: 5px;
    color: #000;
    font-size: 13px;
  }

  .cardWrapper {
    text-align: center;
    justify-content: center;
    margin: 20px;
  }

  .cardButton {
    padding: 10px;
    margin: 10px;
    cursor: pointer;
    box-shadow: 0 0 2px;
    transition: all 0.5s ease-in;
    width: 140px;
  }

  .cardActive {
    background-color: #004aad;
    color: #fff;
  }

  .react-selectbox{
    font-size: 12px;
  }

  .notes {
    background-color: #ccc;
    padding: 10px;
    border-radius: 10px;
  }


  /* Circular progress Bar */
  .circularbox .percent {
    position: relative;
    width: 150px;
    height: 150px;
  }

  .circularbox .percent svg {
    position: relative;
    width: 150px;
    height: 150px;
  }

  .circularbox .percent svg circle {
    width: 120px;
    height: 120px;
    fill: none;
    stroke-width: 7;
    /* stroke: #004aad; */
    transform: translate(5px, 5px);
    stroke-dasharray: 440;
    stroke-dashoffset: 440;
    stroke-linecap: circle;
  }

  .circularbox .percent svg circle:nth-child(1) {
    stroke-dashoffset: 0;
    stroke: #f3f3f3;
  }

  .circularbox .percent svg circle:nth-child(2) {
    stroke-dashoffset: calc(440 - (440 * 50) / 100);
    /* stroke: green; */
  }


  .circularbox .percent .number {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #222;
    font-weight: bold;
    letter-spacing: 3px;
  }

  .circularbox .percent .number h5 {
    font-size: 20px;
  }

  .circularbox .text {
    color: #222;
    font-weight: 700;
    font-size: 14px;
  }

  .number {
    font-size: 22px;
    font-weight: 600;
    display: inline-block;
  }

  .determinationChartsImages {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: cover;
  }


  .btn-link:hover {
    text-decoration: none !important;
  }

  .deviceStatsNumber {
    padding: 10px;
    width: 70px;
    text-align: center;
    justify-content: center;
    color: #FFF
  }

  .card {
    background-color: #FFF;
  }

  .monthly-target-card {
    background-color: #004aad;
    /* background-image: linear-gradient(#2c3e50, #3498db); */
  }

  .analytics-card {
    box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);
    /* border-radius: 25px; */
    background-color: #FEFFFF;
    border-bottom: 3px solid #467FFF
  }

  .consentCard {
    background-color: #EAEAEA;
  }

  .circleBg {
    font-size:20px;
    color: '#999';
    padding-right: 15px;
  }

  .deviceHistoryIcons {
    font-size: 42px;
    padding: 5px;
    color: #004aad
  }

  /* common */

.ribbon {
  width: 130px;
  height: 130px;
  overflow: hidden;
  position: absolute;
}

.ribbon span {
  position: absolute;
  display: block;
  width: 225px;
  padding: 3px 0;
  background-color: #004aad;
  box-shadow: 0 5px 10px rgba(0,0,0,.1);
  color: #fff;
  font: 700 14px;
  text-shadow: 0 1px 1px rgba(0,0,0,.2);
  text-transform: uppercase;
  text-align: center;
}

/* top left*/
.ribbon-top-left {
  top: -10px;
  left: -10px;
}
.ribbon-top-left::before,
.ribbon-top-left::after {
  border-top-color: transparent;
  border-left-color: transparent;
}
.ribbon-top-left::before {
  top: 0;
  right: 0;
}
.ribbon-top-left::after {
  bottom: 0;
  left: 0;
}
.ribbon-top-left span {
  right: -25px;
  top: 30px;
  transform: rotate(-45deg);
}

.chatButton {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 99;
}

.roundedChatButton {
  display:block;
  height: 80px;
  width: 80px;
  border-radius: 50%;
  background-color: #FFF;
  border: 4px solid #004aad;
  color: #000;
  box-shadow: 5px 5px 10px 2px rgba(0,0,0,.8);
}

.roundedImage {
  height: 60px;
  width: 60px;
  border-radius: 50%;
  border: 3px solid gray;
  padding: 5px;
}

.borderedSection {
  border: 2px solid #EAEAEA;
  padding: 20px;
  border-radius: 10px;
}

.activeChat {
  padding-left: 8px;
  padding-top: 8px;
  padding-bottom: 8px;
  background-color: #004aad;
  color: #FFF;
  border-radius: 10px;

}

.activeChat:hover {
  /* background-color: #EAEAEA; */
  cursor: pointer;
}

.chatTextaArea {
  position: absolute;
  bottom: 10px;
  width: 94%;
}

.textMessageArea {
  border: 1px solid #000;
  height: 50px;
}

.title {
  color: #0E194F;
  font-weight: 600;
}

.nursesList {
  border: 2px solid #004aad;
  border-radius: 10px;
  padding: 5px;
  margin: 10px
}

.nursesList:hover {
  border: 2px solid #004aad;
  background-color: #004aad;
  color: #FFF;
  transition: all .4s;
}

.pills {
  background-color: #eae2b7;
  color: #004aad;
  border-radius: 25px;
  padding: 10px 15px
}

.edit-pill {
  appearance: none;
  background-color: #0E194F;
  border: 1px solid #FFF;
  border-radius: 6px;
  box-shadow: rgba(27, 31, 35, 0.04) 0 1px 0, rgba(255, 255, 255, 0.25) 0 1px 0 inset;
  box-sizing: border-box;
  color: #FFF;
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  list-style: none;
  padding: 6px 16px;
  position: relative;
  transition: background-color 0.2s cubic-bezier(0.3, 0, 0.5, 1);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: middle;
  white-space: nowrap;
  word-wrap: break-word;
  text-decoration: none !important;
}


.blue-pills {
  background-color: #004aad;
  color: #FFF;
  border-radius: 15px;
  padding: 0px 15px
}

.recent-readings-card {
  border-radius: 10px;
  padding: 10px;
  max-height: 720px;
  overflow-y: auto;
}

.shrinkText{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.targetedMinutesCard{
  max-height: 960px;
  overflow-y: auto;
}

.colored-row {
  background-color: #EAEAEA;
  margin: 0;
  padding: 10px;
  border-radius: 10px;
}

.welcomeBack-background {
  background-color: #EAE2B7;
  border-radius: 15px; 
  padding: 40px; 
  margin: 0
}

.welcomeBack-heading {
  color: #004aad;
  font-weight: bold;
}

.w3-blue{
  background-color:#004aad;
  margin: 5px;
  border-radius: 5px;
}

.coloredRow {
  background-color: #EAE2B7;
}

.newSpan {
  background-color: orange;
  padding: 5px;
  border-radius: 5px;
  font-size: 10px;
}

/* New dropdowns */
.dropdown-bg {
  background-color: #FFF;
  color: #004aad;
  padding: 10px;
  margin: 10px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border-radius: 20px;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #FFFFFF;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  padding: 12px 16px;
  z-index: 1;
  margin-top: 12px;
  border-radius: 20px;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.roundedBorderImg {
  border: 4px solid #219EBC;
  padding: 4px;
  border-radius: 50%;
  background-color: #EAE2B7;
}

.reddishRow {
  /* background-color: #F2BEBF */
  background-color: #FBD9D3;

}

.rounded-btn {
  border-radius: 50px;
  padding: 18px;
  margin-left: -30px !important;
}

.performanceCard {
  background-color: #F8F9FF;
  border: 4px solid white;
  height: 270px;
  border-radius: 15px;
}

.activePerformanceCard {
  /* background-color: #FCCB06; */
  background-color: gold;
}

.justPerformingCard {
  background-color: #008000;
  color: white !important;
}

.underPerformingCard{
  background-color: #ff0000;
  color: white !important;
}

.centeredImg {
  display: block;
  margin-left: auto;
  margin-right: auto;
}



/* Tables size to their content; when wider than the page they scroll inside their own container. */
.table-responsive { overflow-x: auto; max-width: 100%; }
table td, table th { overflow-wrap: normal; word-break: normal; }
table td.text-nowrap, table th.text-nowrap { white-space: nowrap; }

/* Sidebar: long labels wrap inside their own row (rows grow) instead of spilling over the next item. */
.sidebar .nav-links li { height: auto; min-height: 50px; }
.sidebar .nav-links li a { height: auto; min-height: 50px; padding-right: 8px; }
.sidebar .nav-links li a i { flex: 0 0 auto; }
.sidebar .nav-links li a .link_name { flex: 1 1 auto; min-width: 0; white-space: normal; line-height: 1.25; overflow-wrap: anywhere; padding: 4px 0; }
.sidebar .link-name-active { letter-spacing: normal; }

/* Shared sortable table headers (components/SortableTable.js) */
.sortable-th-btn { background: none; border: 0; padding: 0; margin: 0; font: inherit; color: inherit; font-weight: inherit; text-align: inherit; cursor: pointer; display: inline-flex; align-items: center; gap: 4px; white-space: nowrap; }
.sortable-th-btn:focus-visible { outline: 2px solid #004aad; outline-offset: 2px; border-radius: 2px; }
.sortable-th-btn .sort-arrow { font-size: 0.75em; opacity: 0.35; }
.sortable-th-btn .sort-arrow-active { opacity: 1; }

/* Vitals Portal branding: "Powered by The Doctors Web" + site footer */
.vp-powered-by { font-size: 11px; color: #6c757d; letter-spacing: .3px; text-align: center; }
.sidebar .vp-powered-by { color: #AEB6D6; margin: 0 0 10px; white-space: nowrap; }
.sidebar.active .vp-powered-by { display: none; }
.vp-site-footer { font-size: 12px; color: #8a8f98; text-align: center; padding: 10px 16px; }
body:has(.sidebar) .vp-site-footer { padding-left: 290px; }
body:has(.sidebar.active) .vp-site-footer { padding-left: 60px; }
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"EAAE;IACE,qCAAqC;IACrC,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;IACpB,UAAU;IACV,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB;EACF;;EAEA;IACE,mBAAmB;IACnB;EACF;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IAGnB,+CAA+C;IAC/C;EACF;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IAGnB,+CAA+C;IAC/C,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IAGnB,+CAA+C;IAC/C,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;;EAGA,oBAAoB;EACpB;IACE,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,mDAAmD;IAGnD,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;EACA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,eAAe;IACf;EACF;;EAEA,6BAA6B;;EAE7B;IACE,qBAAqB;IACrB,2CAA2C;IAC3C,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB;EACF;;;EAGA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;EAEA;;qEAEmE;EACnE;IACE,sBAAsB;IACtB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,sBAAsB;IACtB,uBAAuB;IACvB,kDAAkD;IAClD,sCAAsC;EACxC;;EAEA;IACE;MACE,oBAAoB;MACpB,iEAAiE;IACnE;IACA;MACE,yBAAyB;MACzB,8DAA8D;IAChE;IACA;MACE,0BAA0B;IAC5B;EACF;;EAEA;;iEAE+D;EAC/D;IACE,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;;EAGA;;iEAE+D;EAC/D;IACE,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;IACZ,cAAc;IACd,SAAS;IACT,gDAAgD;EAClD;;EAEA;IACE,MAAM;EACR;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;IACf,SAAS;IACT,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,oCAAoC;EACtC;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;;EAGA;IACE,WAAW;IACX,eAAe;IACf,cAAc;IACd,mCAAmC;IACnC,YAAY;EACd;;EAEA;IACE,WAAW;IACX,eAAe;IACf,cAAc;IACd,mCAAmC;EACrC;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,cAAc;IACd,mCAAmC;EACrC;;EAEA;;GAEC;EACD;IACE,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,qBAAqB;EACvB;;;EAGA;;iEAE+D;EAC/D;IACE,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB;EACF;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV;EACF;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV;EACF;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;;;EAGA;;kEAEgE;EAChE;IACE,WAAW;IACX,YAAY;IACZ,mDAA8C;IAC9C,sBAAsB;IACtB,4BAA4B;IAC5B;EACF;;EAEA;IACE;EACF;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,6BAA6B;IAC7B,gCAAgC;IAChC,WAAW;IACX,UAAU;IACV,kBAAkB;EACpB;;EAEA;;iEAE+D;EAC/D;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,aAAa;IACb,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;;mEAEiE;;EAEjE;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,wCAAwC;EAC1C;;EAEA;IACE,gBAAgB;IAChB,wCAAwC;EAC1C;EACA;;kEAEgE;EAChE;IACE;EACF;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB;EACF;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;;EAEnB;;EAEA;;kEAEgE;;EAEhE;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB;EACF;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uCAAuC;;EAEzC;;;EAGA;IACE,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uCAAuC;EACzC;;;EAGA;;iEAE+D;EAC/D;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;;EAGA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,oFAAoF;EACpF;IACE,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;iEAE+D;EAC/D;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAWA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;;;EAGA;;iEAE+D;;EAE/D;IACE,mBAAmB;IACnB,sBAAsB;IACtB;EACF;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA,6FAA6F;;;EAG7F,kGAAkG;;EAElG,YAAY;EACZ;IACE,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,cAAc;IACd,eAAe;IACf,0BAA0B;EAC5B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA,uBAAuB;EACvB;IACE,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,yBAAyB;EAC3B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;;EAGA;IACE,YAAY;IACZ,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE;EACF;;;EAGA;IACE,+BAA+B;IAC/B,yBAAyB;EAC3B;;;EAGA,iBAAiB;EACjB;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,6BAA6B;IAC7B;EACF;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,yBAAyB;EAC3B;;;EAGA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;IAC5B,qDAAqD;IACrD,gCAAgC;EAClC;;EAEA;IACE,mDAAmD;EACrD;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,oDAAoD;EACtD;;;;EAIA;IACE,eAAe;IACf,gBAAgB;IAChB;EACF;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,sBAAsB;EACxB;;;EAGA;IACE,aAAa;IACb,mBAAmB;IACnB;EACF;;;EAGA;IACE,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf;EACF;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;;;EAIA,oBAAoB;EACpB;IACE,gBAAgB;IAChB,mBAAmB;IACnB,uCAAuC;IACvC,gBAAgB;EAClB;;EAEA,kBAAkB;EAClB;IACE,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,2BAA2B;IAC3B,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;EACA;;iEAE+D;;EAE/D;IACE,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,4BAA4B;IAC5B,oBAAoB;IACpB,yBAAiB;YAAjB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,mBAAmB;MACnB,YAAY;MACZ,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,WAAW;MACX,WAAW;MACX,cAAc;IAChB;EACF;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,wCAAwC;IACxC,UAAU;IACV,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;;EAGA,QAAQ;EACR;IACE,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,wCAAwC;IACxC,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,wCAAwC;IACxC,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE;EACF;;EAEA,0EAA0E;EAC1E;IACE,wBAAwB;IACxB,cAAc;IACd,cAAc;IACd,UAAU;IACV,4BAA4B;IAC5B;;EAEF;;EAEA;IACE;EACF;;;EAGA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,4CAA4C;;EAE9C;;EAEA;IACE,mBAAmB;IACnB,gCAAgC;IAChC,WAAW;IACX;EACF;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB;EACF;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA,eAAe;EACf;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE;EACF;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;;;EAGA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;IACrB;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,yBAAyB;IAEzB,sCAAsC;IACtC,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX;EACF;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,SAAS;IACT,UAAU;IACV,aAAa;IACb,gBAAgB;;EAElB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;;EAEzB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;;EAGA;;GAEC;EACD;IACE,cAAc;IACd,eAAe;IACf,eAAe;IACf,aAAa;IACb,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;;;EAIA;IACE;MACE,cAAc;IAChB;IACA;MACE,aAAa;IACf;EACF;;;EAGA;IACE,eAAe;IACf,gBAAgB;IAChB,MAAM;IACN,QAAQ;IACR,OAAO;IACP,SAAS;IACT,iCAAiC;IACjC,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;;iEAE+D;EAC/D;IACE,WAAW;IACX,aAAa;IACb,8DAA8D;IAC9D,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,oBAAoB;EACpB;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ;EACF;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IAEE,sCAAsC;IACtC,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,wCAAwC;IACxC,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gCAAgC;IAChC,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ;EACF;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;;EAGA;IACE,eAAe;IACf,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,4BAA4B;IAC5B,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,mBAAmB;EACrB;;;EAGA,0BAA0B;EAC1B;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,UAAU;IACV,eAAe;IACf,qBAAqB;IACrB,8BAA8B;IAC9B,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,+CAA+C;IAC/C,mBAAmB;EACrB;;;EAGA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,sBAAsB;IACtB,0BAA0B;EAC5B;;;EAGA;IACE,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB;EACF;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,yDAAyD;EAC3D;;EAEA;IACE,2CAA2C;IAC3C,yBAAyB;IACzB,yBAAyB;IACzB;EACF;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ;EACF;;EAEA,WAAW;;AAEb;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,qCAAqC;EACrC,WAAW;EACX,cAAc;EACd,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,UAAU;EACV,WAAW;AACb;AACA;;EAEE,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,MAAM;EACN,QAAQ;AACV;AACA;EACE,SAAS;EACT,OAAO;AACT;AACA;EACE,YAAY;EACZ,SAAS;EACT,yBAAyB;AAC3B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,WAAW;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,mBAAmB;;AAErB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ;AACF;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB;AACF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,mFAAmF;EACnF,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,8DAA8D;EAC9D,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;AAClC;;;AAGA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;;AAE3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;;;AAIA,mGAAmG;AACnG,oBAAoB,gBAAgB,EAAE,eAAe,EAAE;AACvD,qBAAqB,qBAAqB,EAAE,kBAAkB,EAAE;AAChE,6CAA6C,mBAAmB,EAAE;;AAElE,uGAAuG;AACvG,yBAAyB,YAAY,EAAE,gBAAgB,EAAE;AACzD,2BAA2B,YAAY,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC/E,6BAA6B,cAAc,EAAE;AAC7C,sCAAsC,cAAc,EAAE,YAAY,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,uBAAuB,EAAE,cAAc,EAAE;AACrJ,6BAA6B,sBAAsB,EAAE;;AAErD,gEAAgE;AAChE,mBAAmB,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE,SAAS,EAAE,aAAa,EAAE,cAAc,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,eAAe,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AAC5O,iCAAiC,0BAA0B,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACtG,+BAA+B,iBAAiB,EAAE,aAAa,EAAE;AACjE,sCAAsC,UAAU,EAAE;;AAElD,uEAAuE;AACvE,iBAAiB,eAAe,EAAE,cAAc,EAAE,oBAAoB,EAAE,kBAAkB,EAAE;AAC5F,0BAA0B,cAAc,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AACjF,iCAAiC,aAAa,EAAE;AAChD,kBAAkB,eAAe,EAAE,cAAc,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AAC3F,qCAAqC,mBAAmB,EAAE;AAC1D,4CAA4C,kBAAkB,EAAE","sourcesContent":["  *{\n    font-family: 'Montserrat', sans-serif;\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n    scroll-behavior: smooth;\n  }\n\n  *::-webkit-scrollbar {\n    width: 3px;\n    border-radius: 10px;\n  }\n\n  *::-webkit-scrollbar-track {\n    background: #FFF;\n  }\n\n  *::-webkit-scrollbar-thumb {\n    background-color: #555;\n  }\n\n  .error {\n    position: 'absolute';\n    color: red;\n    font-size: 0.8rem;\n    margin-top: 4px;\n  }\n\n  .blue-hr {\n    background: #081D45;\n    height: 1px\n  }\n\n  .white-hr {\n    background: #EAEAEA;\n    height: 1px\n  }\n\n  .admindashboardbody {\n    overflow-x:hidden;\n    overflow-y:hidden;\n  }\n\n  .rounded-card {\n    border-radius: 25px;\n  }\n\n  .card-bordered {\n    background-color: #0F2557;\n    border-radius: 20px;\n    -webkit-box-shadow: -1px -3px 13px 0px rgba(0,0,0,0.44);\n    -moz-box-shadow: -1px -3px 13px 0px rgba(0,0,0,0.44);\n    box-shadow: -1px -3px 13px 0px rgba(0,0,0,0.44);\n    color: #FFF\n  }\n\n  .card-bordered-01 {\n    background-color: #FFF;\n    border-radius: 10px;\n    -webkit-box-shadow: -1px -3px 13px 0px rgba(0,0,0,0.44);\n    -moz-box-shadow: -1px -3px 13px 0px rgba(0,0,0,0.44);\n    box-shadow: -1px -3px 13px 0px rgba(0,0,0,0.44);\n    text-align: center;\n    justify-content: center;  \n  }\n\n  .card-bordered-02 {\n    background-color: #FFF;\n    border-radius: 20px;\n    -webkit-box-shadow: -1px -3px 13px 0px rgba(0,0,0,0.44);\n    -moz-box-shadow: -1px -3px 13px 0px rgba(0,0,0,0.44);\n    box-shadow: -1px -3px 13px 0px rgba(0,0,0,0.44);\n    text-align: center;\n    justify-content: center;  \n  }\n\n  .activeRPMStatus {\n    color: green;\n    font-weight: 600;\n  }\n\n\n  /* Comment Bubble  */\n  .bubble {\n    box-sizing: border-box;\n    float: left;\n    width: auto;\n    max-width: 80%;\n    position: relative;\n    clear: both;\n    background-image: linear-gradient(#004aad, #004aad);\n    -webkit-border-radius: 20px;\n    -moz-border-radius: 20px;\n    border-radius: 10px;\n    padding: 3px 15px;\n    color: #000;\n    word-wrap: break-word;\n    margin-top: 10px;\n  }\n\n  .bubble-alt {\n    float: left;\n  }\n  .bubble-alt:before {\n    left: auto;\n    right: -7px;\n  }\n  .bubble-alt:after {\n    left: auto;\n    right: -5px;\n  }\n\n  .bubble p {\n    font-size: 14px;\n    color: #FFF\n  }\n\n  /* Comment Bubble ends here */\n\n  .alerts-section {\n    background-color:#FFF;\n    box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);\n    padding: 20px;\n  }\n\n  .alerts-section {\n    max-height: 430px;\n    overflow-y: auto;\n  }\n\n  .not-found-text {\n    color: gray;\n    font-size: 14px;\n    font-weight: bold;\n    width:100%\n  }\n\n\n  .form-label {\n    font-size: 14px;\n    color: #004aad;\n    font-weight: bold;\n  }\n\n  /* ---------------------------------------------------------------\n    Loader\n  ----------------------------------------------------------------- */\n  .loader-area {\n    background-color: #FFF;\n    height: 20%;\n    width: 20%;\n  }\n  \n  .loader {\n    display: inline-block;\n    position: absolute;\n    width: 80px;\n    height: 80px;\n    left: 50%;\n    top: 50%;\n    margin: -40px 0 0 -40px;\n  }\n\n  .loader:after {\n    content: \" \";\n    display: block;\n    border-radius: 50%;\n    width: 0;\n    height: 0;\n    margin: 8px;\n    box-sizing: border-box;\n    border: 32px solid #FFF;\n    border-color: #999 transparent #004aad transparent;\n    animation: lds-hourglass 1.2s infinite;\n  }\n\n  @keyframes lds-hourglass {\n    0% {\n      transform: rotate(0);\n      animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n    }\n    50% {\n      transform: rotate(900deg);\n      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    }\n    100% {\n      transform: rotate(1800deg);\n    }\n  } \n  \n  /*--------------------------------------------------------------\n  # Top Bar\n  --------------------------------------------------------------*/\n  #topbar {\n    background: #004aad;\n    color: #D0D8DA;\n    height: 40px;\n    font-size: 14px;\n    transition: all 0.5s;\n    z-index: 996;\n  }\n\n  #topbar.topbar-scrolled {\n    top: -60px;\n  }\n\n  #topbar .contact-info a {\n    line-height: 1;\n    color: #FFF;\n    transition: 0.3s;\n    letter-spacing: 1px;\n  }\n\n  #topbar .contact-info a:hover {\n    color: #FFF;\n    list-style: none;\n    text-decoration: none;\n  }\n\n  #topbar .contact-info i {\n    color: #FFF;\n    font-size: 22px;\n    padding-right: 4px;\n    margin-left: 35px;\n    line-height: 0;\n  }\n  #topbar .contact-info i:first-child {\n    margin-left: 0;\n  }\n\n  #topbar .social-links a {\n    color: #FFF;\n    padding-left: 25px;\n    display: inline-block;\n    line-height: 1px;\n    transition: 0.3s;\n  }\n\n  #topbar .social-links a:hover {\n    color: #1977cc;\n  }\n\n  #topbar .social-links a:first-child {\n    border-left: 0;\n  }\n\n\n  /*--------------------------------------------------------------\n  # Header\n  --------------------------------------------------------------*/\n  #header {\n    background: #fff;\n    transition: all 0.5s;\n    z-index: 997;\n    padding: 5px 0;\n    top: 40px;\n    box-shadow: 0px 2px 15px rgba(25, 119, 204, 0.1);\n  }\n\n  #header.header-scrolled {\n    top: 0;\n  }\n\n  .logoImg {\n    width: 245px;\n    height: 93px;\n    margin: 0px auto;\n  }\n\n  .landingPageHeaderLogo {\n    width:auto;\n    height: 80px;\n  }\n\n  #header .logo {\n    font-size: 30px;\n    margin: 0;\n    padding: 0;\n    line-height: 1;\n    font-weight: 700;\n    letter-spacing: 0.5px;\n    font-family: 'Open Sans', sans-serif;\n  }\n\n  #header .logo a {\n    color: #004aad;\n    text-decoration: none;\n  }\n\n  #header .logo img {\n    max-height: 40px;\n  }\n\n\n  .male-tag {\n    width: 70px;\n    font-size: 12px;\n    margin: 0 auto;\n    background-color:#004aad !important;\n    opacity: 0.5;\n  }\n\n  .assigned-tag {\n    width: 70px;\n    font-size: 12px;\n    margin: 0 auto;\n    background-color:#004aad !important;\n  }\n\n  .not-assigned-tag {\n    width: 110px;\n    font-size: 12px;\n    margin: 0 auto;\n    background-color:#385399 !important;\n  }\n\n  /**\n  * Appointment Button *\n  */\n  .appointment-btn {\n    margin-left: 25px;\n    background: #004aad;\n    color: #FFF;\n    border-radius: 50px;\n    padding: 8px 25px;\n    white-space: nowrap;\n    transition: 0.3s;\n    font-size: 14px;\n    display: inline-block;\n    box-shadow: 5px 5px 12px #aaaaaa;\n  }\n\n  .appointment-btn:hover {\n    background: #009ABB;\n    color: #fff;\n    text-decoration: none;\n  }\n\n\n  /*--------------------------------------------------------------\n  # Featured Services\n  --------------------------------------------------------------*/\n  .featured-services {\n    background: #004aad;\n    margin: 40px;\n    padding: 10px;\n    border: 3px solid #EEE;\n  }\n\n  .icon-box {\n    text-align: justify;\n    padding: 10px\n  }\n  .icon-box-active {\n    background: #FFF;\n    height: 250px;\n    border-radius: 10px;\n    line-height: 25px;\n    height: 330px;\n    margin-top: -50px;\n    margin-bottom: 20px;\n    text-align: justify;\n    padding: 10px;\n  }\n\n  .icon {\n    color: #004aad;\n    font-size: 30px;\n    background: #DBDCD5;\n    padding: 10px;\n    border-radius: 25px;\n    width:50px;\n    margin: 15px\n  }\n\n  .icon-box-active .icon {\n    color: #004aad;\n    font-size: 30px;\n    background: #DBDCD5;\n    padding: 10px;\n    border-radius: 50px;\n    width:50px;\n    margin: 15px\n  }\n\n  .icon-box-active .description {\n    font-size: 14px;\n  }\n\n  .bordered-box {\n    border-right: 4px solid #EEE;\n  }\n\n\n  /* -------------------------------------------------------------\n  About Us \n  ---------------------------------------------------------------*/\n  .about-us-section{\n    width: 100%;\n    height: 120%;\n    background: url('./assets/Images/RPM_CCM.png');\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position:center\n  }\n\n  .about-us {\n    margin-top:60px\n  }\n\n  .about-us-point {\n    background: #004aad;\n    padding: 10px;\n    border-top-right-radius: 20px;\n    border-bottom-right-radius: 20px;\n    color: #FFF;\n    width: 70%;\n    text-align: center;\n  }\n\n  /*--------------------------------------------------------------\n  # Services\n  --------------------------------------------------------------*/\n  .section {\n    padding: 60px 0;\n    overflow: hidden;\n  }\n\n  .section-bg {\n    padding-bottom: 60px;\n    background-color: #f1f7fd;\n  }\n\n  .section-title {\n    text-align: center;\n    padding-bottom: 30px;\n  }\n\n  .section-title h2 {\n    font-size: 28px;\n    font-weight: bold;\n    margin-bottom: 20px;\n    padding-bottom: 20px;\n    position: relative;\n    color: #2c4964;\n  }\n\n  .section-title h2::before {\n    content: '';\n    position: absolute;\n    display: block;\n    width: 120px;\n    height: 1px;\n    background: #ddd;\n    bottom: 1px;\n    left: calc(50% - 60px);\n  }\n\n  .section-title h2::after {\n    content: '';\n    position: absolute;\n    display: block;\n    width: 40px;\n    height: 3px;\n    background: #1977cc;\n    bottom: 0;\n    left: calc(50% - 20px);\n  }\n\n  .section-title p {\n    margin-bottom: 0;\n  }\n\n  .services .icon-box {\n    text-align: center;\n    border: 1px solid #eee;\n    padding: 80px 20px;\n    transition: all ease-in-out 0.3s;\n  }\n\n  .services .icon-box .icon {\n    margin: 0 auto;\n    width: 64px;\n    height: 64px;\n    background: #FFF;\n    border-radius: 5px;\n    transition: all .3s ease-out 0s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 20px;\n    transform-style: preserve-3d;\n  }\n\n  .services .icon-box .icon img {\n    color: #fff;\n    height: 100px;\n    width: 100px;\n  }\n\n  .services .icon-box h4 {\n    font-weight: 700;\n    margin-bottom: 15px;\n    font-size: 18px;\n  }\n\n  .services .icon-box h4 a {\n    color: #2c4964;\n  }\n\n  .services .icon-box p {\n    line-height: 24px;\n    font-size: 14px;\n    margin-bottom: 0;\n  }\n\n  .services .icon-box:hover {\n    background: #009ABB;\n    border-color: #AABEC6;\n  }\n\n  .services .icon-box:hover .icon {\n    background: #fff;\n  }\n\n  .services .icon-box:hover .icon i {\n    color: #004aad;\n  }\n\n  .services .icon-box:hover .icon::before {\n    background: #3291e6;\n  }\n\n  .services .icon-box:hover h4 a, .services .icon-box:hover p {\n    color: #fff;\n  }\n\n  /* ------------------------------------------------------------\n  RPM Devices Section\n  ----------------------------------------------------------------*/\n\n  .rpm-card-images {\n    width: 80px;\n    height: 80px;\n    margin: 20px 20px;\n    background: #DBDCD5;\n    padding: 17px;\n    border-radius: 50px;\n  }\n\n  .rpm-devices-card-01 {\n    background: #004aad;\n    box-shadow: 0 0 5px 5px rgba(0,0,0, 0.1);\n  }\n\n  .rpm-devices-card-02 {\n    background: #FFF;\n    box-shadow: 0 0 5px 5px rgba(0,0,0, 0.1);\n  }\n  /* ------------------------------------------------------------\n  Telemedine\n  ---------------------------------------------------------------*/\n  .telemedicine-section{\n    padding: 30px\n  }\n\n  .telemedicine-heading {\n    font-size: 28px;\n    font-weight: bold;\n    margin-bottom: 10px;\n    padding-bottom: 10px;\n    text-align: left;\n    color: #2c4964;\n  } \n\n  .telemedine-subheading{\n    font-size: 24px;\n    font-weight: bold;\n    color: #004aad\n  }\n\n  .telemedine-img {\n    width: 440px; \n    height:auto;\n    align-self: center;\n    margin-top: -90px;\n    margin-left: 20px;\n\n  }\n\n  /* ------------------------------------------------------------\n  How it works\n  ---------------------------------------------------------------*/\n\n  .how-it-works-icon {\n    width: 50px;\n    height: auto;\n    margin: 10px;\n    background-color: #DBDCD5;\n    border-radius: 50px;\n    padding: 5px\n  }\n\n  .how-it-works-card-01 {\n    background-color: #004aad;\n    color: #FFF;\n    padding: 15px;\n    border-radius: 25px;\n    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);\n\n  }\n\n\n  .how-it-works-card-04 {\n    background-color: #004aad;\n    color: #FFF;\n    padding: 15px;\n    border-radius: 25px;\n    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);\n  }\n\n\n  /*--------------------------------------------------------------\n  # Appointments\n  --------------------------------------------------------------*/\n  .appointment .php-email-form {\n    width: 100%;\n  }\n\n  .appointment .php-email-form .form-group {\n    padding-bottom: 8px;\n  }\n\n\n  .appointment .php-email-form input, .appointment .php-email-form textarea, .appointment .php-email-form select {\n    border-radius: 0;\n    box-shadow: none;\n    font-size: 14px;\n    padding: 5px !important;\n  }\n\n  .appointment .php-email-form input:focus, .appointment .php-email-form textarea:focus, .appointment .php-email-form select:focus {\n    border-color: #000 !important;\n  }\n\n  .appointment .php-email-form input, .appointment .php-email-form select {\n    height: 44px;\n  }\n\n  .appointment .php-email-form textarea {\n    padding: 10px 12px;\n  }\n\n  .appointment .php-email-form button[type=\"submit\"] {\n    background: #004aad;\n    border: 0;\n    padding: 10px 35px;\n    color: #fff;\n    transition: 0.4s;\n    border-radius: 50px;\n  }\n\n  .appointment .php-email-form button[type=\"submit\"]:hover {\n    background: #004aad;\n  }\n\n  /************************************ Contact Map ******************************** */\n  .mapouter {\n    position:relative;\n    text-align:right;\n    width:100%;\n    height:363px;\n  }\n\n  .gmap_canvas {\n    overflow:hidden;\n    background:none!important;\n    width:100%;\n    height:363px;\n  }\n\n  .gmap_iframe {\n    height:363px!important;\n  }\n\n  /*--------------------------------------------------------------\n  # Contact\n  --------------------------------------------------------------*/\n  .contact .info {\n    width: 100%;\n    background: #fff;\n  }\n\n  .contact .info img {\n    width: 30px;\n    height: 30px;\n    float: left;\n    width: 44px;\n    height: 44px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    transition: all 0.3s ease-in-out;\n  }\n\n  .contact .info h4 {\n    padding: 0 0 0 60px;\n    font-size: 22px;\n    font-weight: 600;\n    margin-bottom: 5px;\n    color: #2c4964;\n  }\n\n  .contact .info p {\n    padding: 0 0 0 60px;\n    margin-bottom: 0;\n    font-size: 14px;\n    color: #4b7dab;\n  }\n\n  .contact .info .email, .contact .info .phone {\n    margin-top: 40px;\n  }\n\n  .contact .info .email:hover i, .contact .info .address:hover i, .contact .info .phone:hover i {\n    background: #3fbbc0;\n    color: #fff;\n  }\n\n  .contact .php-email-form {\n    width: 100%;\n    background: #fff;\n  }\n\n  .contact .php-email-form .form-group {\n    padding-bottom: 8px;\n  }\n\n  .contact .php-email-form input, .contact .php-email-form textarea {\n    border-radius: 0;\n    box-shadow: none;\n    font-size: 14px;\n  }\n\n  .contact .php-email-form input {\n    height: 44px;\n  }\n\n  .contact .php-email-form textarea {\n    padding: 10px 12px;\n  }\n\n  .contact .php-email-form button[type=\"submit\"] {\n    background: #004aad;\n    border: 0;\n    padding: 10px 35px;\n    color: #fff;\n    transition: 0.4s;\n    border-radius: 50px;\n  }\n\n  .contact .php-email-form button[type=\"submit\"]:hover {\n    background:#3fbbc0;\n  }\n\n  @-webkit-keyframes animate-loading {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  @keyframes animate-loading {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n\n  /*--------------------------------------------------------------\n  # Footer\n  --------------------------------------------------------------*/\n\n  #footer .footer-top {\n    background: #004aad;\n    padding: 60px 0 30px 0;\n    color: #FFF\n  }\n\n  #footer .footer-top .footer-info {\n    margin-bottom: 30px;\n  }\n\n  #footer .footer-top .footer-info h3 {\n    font-size: 24px;\n    margin: 0 0 20px 0;\n    padding: 2px 0 2px 0;\n    line-height: 1;\n    font-weight: 700;\n  }\n\n  #footer .footer-top .footer-info p {\n    font-size: 14px;\n    line-height: 24px;\n    margin-bottom: 0;\n  }\n\n  #footer .footer-top .social-links a {\n    font-size: 18px;\n    display: inline-block;\n    background: #D0D8DA;\n    color: #09425A;\n    line-height: 1;\n    padding: 8px 0;\n    margin-right: 4px;\n    border-radius: 4px;\n    text-align: center;\n    width: 36px;\n    height: 36px;\n    transition: 0.3s;\n  }\n\n  #footer .footer-top .social-links a:hover {\n    background: #65c9cd;\n    text-decoration: none;\n  }\n\n  #footer .footer-top h4 {\n    font-size: 16px;\n    font-weight: 600;\n    position: relative;\n    padding-bottom: 12px;\n  }\n\n  #footer .footer-top .footer-links {\n    margin-bottom: 30px;\n  }\n\n  #footer .footer-top .footer-links ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n  }\n\n  #footer .footer-top .footer-links ul i {\n    padding-right: 2px;\n    color: #FFF;\n    font-size: 18px;\n    line-height: 1;\n  }\n\n  #footer .footer-top .footer-links ul li {\n    padding: 10px;\n    display: flex;\n    align-items: center;\n  }\n\n  #footer .footer-top .footer-links ul li:first-child {\n    padding-top: 0;\n  }\n\n  #footer .footer-top .footer-links ul a {\n    color: #FFF;\n    transition: 0.3s;\n    display: inline-block;\n    line-height: 1;\n  }\n\n  #footer .footer-top .footer-links ul a:hover {\n    color: #3fbbc0;\n  }\n\n  #footer .footer-top .footer-newsletter form {\n    margin-top: 30px;\n    background: #fff;\n    padding: 6px 10px;\n    position: relative;\n    border: 1px solid #d5d5d5;\n    border-radius: 4px;\n  }\n\n  #footer .footer-top .footer-newsletter form input[type=\"email\"] {\n    border: 0;\n    padding: 4px;\n    width: calc(100% - 110px);\n  }\n\n  #footer .footer-top .footer-newsletter form input[type=\"submit\"] {\n    position: absolute;\n    top: -1px;\n    right: -1px;\n    bottom: -1px;\n    border: 0;\n    background: none;\n    font-size: 16px;\n    padding: 0 20px;\n    background: #1977cc;\n    color: #fff;\n    transition: 0.3s;\n    border-radius: 0 4px 4px 0;\n  }\n\n  #footer .footer-top .footer-newsletter form input[type=\"submit\"]:hover {\n    background: #65c9cd;\n  }\n\n  #footer .copyright {\n    text-align: center;\n    padding-top: 30px;\n  }\n\n  #footer .credits {\n    padding-top: 10px;\n    text-align: center;\n    font-size: 13px;\n  }\n\n  /**********************************Landing Page Ends Here ***********************************/\n\n\n  /**********************************Admin Dashboard Starts Here ***********************************/\n\n  /* Sidebar */\n  .sidebar {\n    position: fixed;\n    height: 100%;\n    width: 280px;\n    background-color: #0E194F;\n    transition: all 0.5s ease;\n    overflow-y: auto;\n  }\n\n  .sidebar.active{\n    width: 60px;\n    transition: all 0.5s ease;\n  }\n\n  .sidebar .logo-details {\n    height: 80px;\n    display: flex;\n    align-items: center;\n  }\n\n  .sidebar .logo-details i {\n    font-size: 24px;\n    color: #FEFFFF;\n    min-width: 50px;\n    text-align: center;\n    margin-top: 20px;\n  }\n\n  .sidebar .logo-details .logo_name{\n    font-size: 22px;\n    font-weight: 500;\n    color: #CCCCCC;\n    margin-top: 20px;\n  }\n\n  .sidebar .nav-links li {\n    height:50px;\n    width: 100%;\n    list-style: none;\n  }\n\n  .sidebar .nav-links li a {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    transition: all 0.4s ease;\n  }\n\n  .sidebar .nav-links li a i {\n    min-width: 40px;\n    text-align: center;\n    margin: 15px;\n    padding: 6px;\n  }\n\n  .sidebar .nav-links li a .link_name{\n    color: #3A3A3F;\n    font-size: 14px;\n    text-transform: capitalize;\n  }\n\n  .sidebar .nav-links li a .link_name{\n    color: #FEFFFF; \n  }\n\n  .link-name-active {\n    background-color: #212A64;\n    font-weight: bold;\n    letter-spacing: 1px;\n  }\n\n  .sidebarBtn {\n    cursor: pointer;\n  }\n\n  /* Home - Section CSS */\n  .home-section {\n    background: #FFF;\n    position: relative;\n    min-height: 100vh;\n    width: calc(100% - 290px);\n    left: 290px;\n    transition: all 0.5s ease;\n  }\n\n  .sidebar.active ~ .home-section{\n    width: calc(100% - 60px);\n    left: 60px;\n  }\n\n  .home-section nav{\n    width: 100%;\n    height: 50px;\n    background: #FFF;\n    padding: 0 10px;\n    display: flex;\n    align-items: center;\n    /* justify-content: space-between; */\n    transition: all 0.4s ease;\n  }\n\n  .sidebar.active ~ .home-section nav {\n    width: 100%;\n  }\n\n  .sidebar-button {\n    display: flex;\n    align-items: center;\n    font-size: 24px;\n    font-weight: 500;\n  }\n\n  .sidebar-button i{\n    font-size: 35px;\n    margin-right: 10px;\n  }\n\n\n  .profile-details img{\n    height: 50px;\n    width: 55px;\n    border-radius: 25px;\n  }\n\n  .profile-details .admin-name{\n    font-size: 15px;\n    font-weight: 500;\n    color: dodgerblue;\n    margin: 0 10px;\n    white-space: nowrap;\n  }\n\n  .navbar-top {\n    margin-bottom: 10px;\n  }\n\n  .notification-dropdown {\n    margin-left: 10px;\n    margin-right: 20px;\n  }\n\n  .admin-topbar-dropdown {\n    width: 70px !important;\n    margin: 10px;\n  }\n\n  .admin-topbar-notification-dropdown {\n    width: 550px !important;\n    max-height: 430px;\n    overflow-y: auto;\n    overflow-x:hidden;\n  }\n\n  .notification-text {\n    font-size:12px;\n    text-decoration: none;\n    background-color: #CCC;\n    padding: 10px;\n  }\n\n  .notification-text p {\n    color: #222;\n  }\n\n  .drop-down-item-active:hover {\n    background-color: #F1F1F1;\n  }\n\n  .drop-down-item-active:active{\n    background-color: #F1F1F1\n  }\n\n\n  .searchArea {\n    /* background-color: #6bd0f1; */\n    background-color: #eae2b7;                \n  }\n\n\n  /* Home Content */\n  .home-section .home-content {\n    position: relative;\n  }\n\n  .home-content .overview-boxes {\n    display: flex;\n    width: 100%;\n    justify-content: space-around;\n    padding: 0 5px\n  }\n\n  .form-control {\n    font-size: 14px;\n    background-color: #FFF;\n  }\n\n  .form-control:focus {\n    outline: none;\n    border: 3px solid #004aad;\n  }\n\n\n  .home-content .overview-boxes .box{\n    display: flex;\n    align-items: center;\n    padding: 15px 14px;\n    justify-content: center;\n    border-radius: 12px;\n    width: calc(100% / 4 - 15px);\n    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n    border-bottom: 3px solid #0E194F;\n  }\n\n  .home-content .overview-boxes .box0{\n    background-image: linear-gradient(#1E3B70, #29539B);\n  }\n\n  .home-content .overview-boxes .box1{\n    background-image: linear-gradient(#0ba360 , #3cba92);\n  }\n\n  .home-content .overview-boxes .box2{\n    background-image: linear-gradient(#06beb6 , #48b1bf);\n  }\n\n  .home-content .overview-boxes .box3{\n    background-image: linear-gradient(#F5515F , #A1051D);\n  }\n\n  .home-content .overview-boxes .staff-box0{\n    background-image: linear-gradient(#061c27 , #023047);\n  }\n\n  .home-content .overview-boxes .staff-box1{\n    background-image: linear-gradient(#a37e21 , #FFB703);\n  }\n\n  .home-content .overview-boxes .staff-box2{\n    background-image: linear-gradient(#2d525c , #219EBC);\n  }\n\n\n\n  .home-content .overview-boxes .box_topic {\n    font-size: 20px;\n    font-weight: 500;\n    color: #222\n  }\n\n  .home-content .overview-boxes .box_topic:hover {\n    text-decoration: none;\n  }\n\n  .home-content .overview-boxes .number {\n    font-size: 30px;\n    font-weight: 900;\n    display: inline-block;\n    color: #0E194F;\n    font-family:sans-serif;\n  }\n\n\n  .overview-boxes .indicator {\n    display: flex;\n    align-items: center;\n    margin-top: 15px\n  }\n\n\n  .overview-boxes .indicator i{\n    height: 20px;\n    width: 20px;\n    background: #8FDACB;\n    color: #FFF;\n    border-radius: 50%;\n    font-size: 20px;\n    margin-right: 5px;\n  }\n\n  .overview-boxes .indicator i.down{\n    background: #e47474;\n  }\n\n  .overview-boxes .indicator .text{\n    font-size: 12px;\n    color: #222\n  }\n\n  .overview-boxes .box .cart {\n    font-size: 32px;\n    font-weight: 500;\n    height:70px;\n    width: 70px; \n    color: #FFF;\n    line-height: 50px;\n    text-align: center;\n    border-radius: 12px;\n  }\n\n\n\n  /* Dashboard Cards */\n  .rpm-devices-card {\n    background: #FFF;\n    border-radius: 12px;\n    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n    transition: 0.3s;\n  }\n\n  /* table classes */\n  table {\n    border:1px solid #D3D3D3;\n    border-collapse: collapse;\n    table-layout: auto;\n  }\n\n  table tr td{\n    text-align: center;\n    justify-content: center;\n    padding: 3px 0px !important;\n    margin: 0 !important;\n  }\n\n  th {\n    background-color: #EAEAEA;\n    color: #000;\n    letter-spacing: 1px;    \n  }\n\n  tr {\n    color: #444;\n    font-size: 14px;\n  }\n  /*--------------------------------------------------------------\n  # Admin Login Form\n  --------------------------------------------------------------*/\n\n  .login-section {\n    position: relative;\n    background: #ffffff;\n    height:100vh;\n    overflow-y: hidden;\n    overflow-x: hidden;\n  }\n\n  .login-illustration {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: left center;\n    pointer-events: none;\n    user-select: none;\n  }\n\n  .login-section > .container {\n    position: relative;\n  }\n\n  @media (max-width: 991px) {\n    .login-section .content {\n      width: 55%;\n    }\n  }\n\n  @media (max-width: 767px) {\n    .login-section {\n      background: #0c41a6;\n      height: auto;\n      min-height: 100vh;\n      overflow-y: auto;\n    }\n\n    .login-illustration {\n      display: none;\n    }\n\n    .login-section .content {\n      width: auto;\n      float: none;\n      margin: 24px 0;\n    }\n  }\n\n  .content {\n    margin: 5%;\n    background: #FAFAFA;\n    border-radius: 10px;\n    padding: 0.5rem;\n    box-shadow: 0 0 5px 5px rgba(0,0,0, .25);\n    width: 35%;\n    float: right;\n    opacity: 0.9;\n  }\n\n  .form-control {\n    outline: none;\n    box-shadow: none;\n    border-color: #D3D3D3;\n  }\n\n  .forgot-password-link {\n    color: #385399;\n    font-size: 12px;\n    margin-top: -4px;\n    float: right;\n    cursor: pointer;\n    margin: 5px;\n    font-weight: 500;\n  }\n\n  .forgot-password-link:hover {\n    text-decoration: none;\n  }\n\n\n  /* CSS */\n  .submit-btn {\n    background-color: #23408e;\n    color: #FFF;\n    padding: 7px;\n    border-radius: 5px;\n    border: none !important;\n    box-shadow: rgba(0, 0, 0, 0.1) 0 2px 4px;\n    margin-bottom: 20px;\n    transition: all .4s;\n    width: 140px;\n    display: block;\n  }\n\n  .submit-btn:hover{\n    color: #fff;\n  }\n\n  .reset-btn {\n    background-color: #004aad;\n    color: #FFF;\n    padding: 5px;\n    border-radius: 5px;\n    border: none !important;\n    box-shadow: rgba(0, 0, 0, 0.1) 0 2px 4px;\n    margin-bottom: 20px;\n    transition: all .4s;\n    min-width: 60px;\n  }\n\n  .row-class {\n    float: right\n  }\n\n  /* -----------------------------Doctor Profile-------------------------- */\n  .profile-card-img {\n    /* border-radius: 50%; */\n    display: table;\n    margin: 0 auto;\n    width: 40%;\n    /* border: 2px solid #222; */\n    padding: 5px\n\n  } \n\n  .card-inner-margin {\n    padding: 20px\n  }\n\n\n  .profile-name {\n    font-size: 16px;\n    margin-top: 5%;\n    font-weight: bold;\n    text-align: center;\n    color: #081D45;\n  }\n\n  .patient-profile-name {\n    font-size: 14px;\n    margin-top: 5%;\n    text-align: center;\n    color: #081D45;\n    text-transform: uppercase;\n  }\n\n  .patient-email {\n    color: gray;\n    font-size: 14px;\n    text-align: center;\n    margin-top: -10px; \n  }\n\n  .doctor-specilizations {\n    color: gray;\n    font-size: 14px;\n    letter-spacing: 2px;\n    text-align: center;\n  }\n\n  .profile-label {\n    color: #010101;\n    font-size: 14px;\n    font-weight: 600;\n  }\n\n  .profile-value-text {\n    color: #333;\n    margin-top: 5px;\n    font-size: 15px;\n  }\n\n  .no-record-found-img {\n    width: 100px;\n    height: 100px;\n    padding: 10px;\n    margin-left: 45%;\n  }\n\n  .dropdown-menu {\n    width: 16%;\n    margin-left: 15px;\n  }\n\n  .jumbotron-blur-img {\n    background-color: #004aad;\n    opacity: 1;\n  }\n\n  .profile-img {\n    height: 180px;\n    width: 180px;\n    border-radius: 50%;\n    vertical-align: middle;\n    border: 3px solid #004aad;\n    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n    \n  }\n\n  .profile-value-bottom-border {\n    letter-spacing: 1px;\n    border-bottom: 4px solid #004aad;\n    margin: 3px;\n    padding: 5px\n  }\n\n  .patient-profile-card-img {\n    width: 80px;\n    border-radius: 50%;\n  }\n\n  .patient-profile-card-img {\n    border: 3px solid gray;\n    padding: 5px\n  }\n\n  .patient-profile-col-heading {\n    background-color: #d9dadb;\n    color: #000;\n    padding: 10px;\n    border-radius: 5px;\n    font-size: 12px;\n    font-weight: 600;\n  }\n\n  .patient-profile-card-text{\n    font-size: 14px;\n  }\n\n  .old-history-span-tag {\n    color: dodgerblue;\n    font-size: 12px;\n  }\n\n  /* Pagination */\n  .page-item.active .page-link {\n    background-color: #004aad;\n    border-color: #D3D3D3;\n  }\n\n  .page-link {\n    color: #000\n  }\n\n  .input-group {\n    width: 90%;\n    margin-right: 35%;\n  }\n\n\n  .list-box-header {\n    margin-top: -5px;\n    margin-bottom: 10px;\n  }\n\n  .header-group {\n    flex-direction: row;\n    justify-content:flex-end;\n  }\n\n  .add-staff-btn {\n    background-color: #23408e;\n    color: #FFF;\n    font-size: 14px;\n    padding: 10px;\n    border-radius: 25px;\n    border: none;\n    float: left;\n    transition: all 0.5s ease;\n  }\n\n  .add-staff-btn:hover {\n    text-decoration: none;\n    color: #F8C113\n  } \n\n  .patient-profile-data-div {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    background-color: #23408e;\n    -webkit-box-shadow: 0px 0px 15px -10px #000000;\n    box-shadow: 0px 0px 15px -10px #000000;\n    color: #FFF;\n    border-radius: 5px;\n  }\n\n  .check-icon {\n    color: #fff;\n  }\n\n  .systolic-image {\n    width: 50px;\n    height: 50px\n  }\n\n  .navbar {\n    padding: 0px;\n    margin: 0px;\n  }\n\n  .navbar ul {\n    margin: 0;\n    padding: 0;\n    display: flex;\n    list-style: none;\n    \n  }\n\n  .navbar li {\n    position: relative;\n  }\n\n  .navbar > ul > li {\n    position: relative;\n    white-space: nowrap;\n    padding: 8px 0 8px 40px;\n    \n  }\n\n  .navbar a, .navbar a:focus {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 16px;\n    color: #2c4964;\n    white-space: nowrap;\n    transition: 0.3s;\n    border-bottom: 2px solid #fff;\n    padding: 5px 2px;\n  }\n\n  .navbar a i, .navbar a:focus i {\n    font-size: 12px;\n    line-height: 0;\n    margin-left: 5px;\n  }\n\n  .navbar a:hover, .navbar .active, .navbar .active:focus, .navbar li:hover > a {\n    color: #1977cc; \n  }\n\n\n  /**\n  * Mobile Navigation \n  */\n  .mobile-nav-toggle {\n    color: #2c4964;\n    font-size: 28px;\n    cursor: pointer;\n    display: none;\n    line-height: 0;\n    transition: 0.5s;\n  }\n\n  .mobile-nav-toggle.bi-x {\n    color: #fff;\n  }\n\n\n\n  @media (max-width: 991px) {\n    .mobile-nav-toggle {\n      display: block;\n    }\n    .navbar ul {\n      display: none;\n    }\n  }\n\n\n  .navbar-mobile {\n    position: fixed;\n    overflow: hidden;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n    background: rgba(28, 47, 65, 0.9);\n    transition: 0.3s;\n    z-index: 999;\n  }\n\n  .navbar-mobile .mobile-nav-toggle {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n  }\n\n  .navbar-mobile ul {\n    display: block;\n    position: absolute;\n    top: 55px;\n    right: 15px;\n    bottom: 15px;\n    left: 15px;\n    padding: 10px 0;\n    background-color: #fff;\n    overflow-y: auto;\n    transition: 0.3s;\n  }\n\n  .navbar-mobile > ul > li {\n    padding: 0;\n  }\n\n  .navbar-mobile a {\n    padding: 10px 20px;\n    font-size: 15px;\n    color: #2c4964;\n    border: none;\n  }\n\n  .navbar-mobile a:hover, .navbar-mobile .active, .navbar-mobile li:hover > a {\n    color: #3fbbc0;\n  }\n\n  .navbar-mobile .getstarted {\n    margin: 15px;\n  }\n\n  /*--------------------------------------------------------------\n  # Home Section\n  --------------------------------------------------------------*/\n  #home {\n    width: 100%;\n    height: 100vh;\n    background: url(\"./assets/Images/RPM_Solution.png\") top center;\n    background-size: cover;\n    margin-bottom: -100px;\n  }\n\n  #home .container {\n    position: relative;\n  }\n\n  #home h1 {\n    margin-top: 70px;\n    font-size: 44px;\n    font-weight: 700;\n    line-height: 56px;\n    text-transform: uppercase;\n    color: #007C92;\n  }\n\n  #home h2 {\n    color: #2c4964;\n    margin: 10px 0 0 0;\n    font-size: 18px;\n    margin-top: 40px;\n    word-spacing: 2px;\n  }\n\n  /* HR & DR Reports */\n  .reportsHeading {\n    background-color: #004aad;\n    color: white;\n    padding: 3px;\n    border-radius: 50px;\n    width: 40px;\n    text-align: center;\n  }\n\n  .report-label{\n    font-size: 14px;\n    color: #222;\n  }\n\n  .spentTime {\n    background-color: #004aad;\n    font-size: 12px;\n    color: #FFF;\n    text-transform: uppercase;\n    padding: 6px;\n    border-radius: 5px\n  }\n\n  .total-time-spent {\n    margin-left: 7px;\n    font-weight: bold;\n    letter-spacing: 1px;\n    padding-top: 15px;\n  }\n\n  .graph-card {\n    -webkit-box-shadow: 0px 0px 15px -10px #000000;\n    box-shadow: 0px 0px 15px -10px #000000;\n    border-radius: 10px;\n  }\n\n  .row-display {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  .row-display-secondary {\n    display: flex;\n    flex-direction: row; \n    border-radius: 5px;\n  }\n\n  .telemetary-patient-row{\n    background-color: #d9dadb;\n    color: gray;\n    font-size: 13px;\n    padding: 4px 0px;\n    border-radius: 10px;\n    letter-spacing: 1px;\n  }\n\n  .form-check-input {\n    font-size: 16px;\n  }\n\n  .newUserGender>input {\n    margin-top: 15px;\n  }\n\n  .newUserGender>label{\n    margin: 10px;\n    font-size: 18px;\n    color: #555;\n  }\n\n  .select-input-type {\n    background-color: #FFF;\n    color: #000;\n    height: 35px;\n    font-size: 14px;\n    width: 140px;\n  }\n\n  .select-input-type:focus {\n    outline: none;\n    box-shadow: none;\n    border-color: #D3D3D3;\n  }\n\n  .telemetary-card {\n    background: #FFF;\n    box-shadow: 0 0 5px 5px rgba(0,0,0, 0.1);\n    margin: 15px 5px;\n    padding: 15px;\n    border-radius: 15px;\n  }\n\n  .logs-card {\n    /* background-color: #CCCCCC; */\n    border-radius: 10px;\n    padding: 10px;\n    color: #FFF;\n    max-height: 760px;\n    overflow-y: auto;\n  }\n\n  .patient-logs-card {\n    background: #F5FAFA;\n    border-radius: 5px;\n    padding: 7px;\n    color: #111;\n    max-height: 250px;\n    overflow-y: auto;\n  }\n\n  .link {\n    text-decoration: none !important; \n    font-size: 14px;\n    color: #004aad;\n    font-weight: bold;\n  }\n\n  .graphWrapper {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .accordion {\n    font-size: 14px;\n    background-color: #F2F2F2;\n    color: #000;\n    padding: 5px;\n    width: 140px;\n    border-radius: 20px; \n    text-align: center;\n    height: 30px;\n    font-weight: bold\n  }\n\n  .accordion:focus {\n    border: none;\n    outline: none;\n  }\n\n  \n  .accordion i {\n    font-size: 14px;\n    float:right;\n    margin-top: 3px;\n    font-weight: bold;\n  }\n\n  .panel {\n    margin-top: 12px;\n  }\n\n  .notes-header {\n    background-color: #fff;\n    padding: 8px;\n    border-radius: 5px;\n    color: #000;\n    font-size: 13px;\n  }\n\n  .cardWrapper {\n    text-align: center;\n    justify-content: center;\n    margin: 20px;\n  }\n\n  .cardButton {\n    padding: 10px;\n    margin: 10px;\n    cursor: pointer;\n    box-shadow: 0 0 2px;\n    transition: all 0.5s ease-in;\n    width: 140px;\n  }\n\n  .cardActive {\n    background-color: #004aad;\n    color: #fff;\n  }\n\n  .react-selectbox{\n    font-size: 12px;\n  }\n\n  .notes {\n    background-color: #ccc;\n    padding: 10px;\n    border-radius: 10px;\n  }\n\n\n  /* Circular progress Bar */\n  .circularbox .percent {\n    position: relative;\n    width: 150px;\n    height: 150px;\n  }\n\n  .circularbox .percent svg {\n    position: relative;\n    width: 150px;\n    height: 150px;\n  }\n\n  .circularbox .percent svg circle {\n    width: 120px;\n    height: 120px;\n    fill: none;\n    stroke-width: 7;\n    /* stroke: #004aad; */\n    transform: translate(5px, 5px);\n    stroke-dasharray: 440;\n    stroke-dashoffset: 440;\n    stroke-linecap: circle;\n  }\n\n  .circularbox .percent svg circle:nth-child(1) {\n    stroke-dashoffset: 0;\n    stroke: #f3f3f3;\n  }\n\n  .circularbox .percent svg circle:nth-child(2) {\n    stroke-dashoffset: calc(440 - (440 * 50) / 100);\n    /* stroke: green; */\n  }\n\n\n  .circularbox .percent .number {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #222;\n    font-weight: bold;\n    letter-spacing: 3px;\n  }\n\n  .circularbox .percent .number h5 {\n    font-size: 20px;\n  }\n\n  .circularbox .text {\n    color: #222;\n    font-weight: 700;\n    font-size: 14px;\n  }\n\n  .number {\n    font-size: 22px;\n    font-weight: 600;\n    display: inline-block;\n  }\n\n  .determinationChartsImages {\n    width: 100%;\n    height: 100%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: cover;\n  }\n\n\n  .btn-link:hover {\n    text-decoration: none !important;\n  }\n\n  .deviceStatsNumber {\n    padding: 10px;\n    width: 70px;\n    text-align: center;\n    justify-content: center;\n    color: #FFF\n  }\n\n  .card {\n    background-color: #FFF;\n  }\n\n  .monthly-target-card {\n    background-color: #004aad;\n    /* background-image: linear-gradient(#2c3e50, #3498db); */\n  }\n\n  .analytics-card {\n    box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);\n    /* border-radius: 25px; */\n    background-color: #FEFFFF;\n    border-bottom: 3px solid #467FFF\n  }\n\n  .consentCard {\n    background-color: #EAEAEA;\n  }\n\n  .circleBg {\n    font-size:20px;\n    color: '#999';\n    padding-right: 15px;\n  }\n\n  .deviceHistoryIcons {\n    font-size: 42px;\n    padding: 5px;\n    color: #004aad\n  }\n\n  /* common */\n\n.ribbon {\n  width: 130px;\n  height: 130px;\n  overflow: hidden;\n  position: absolute;\n}\n\n.ribbon span {\n  position: absolute;\n  display: block;\n  width: 225px;\n  padding: 3px 0;\n  background-color: #004aad;\n  box-shadow: 0 5px 10px rgba(0,0,0,.1);\n  color: #fff;\n  font: 700 14px;\n  text-shadow: 0 1px 1px rgba(0,0,0,.2);\n  text-transform: uppercase;\n  text-align: center;\n}\n\n/* top left*/\n.ribbon-top-left {\n  top: -10px;\n  left: -10px;\n}\n.ribbon-top-left::before,\n.ribbon-top-left::after {\n  border-top-color: transparent;\n  border-left-color: transparent;\n}\n.ribbon-top-left::before {\n  top: 0;\n  right: 0;\n}\n.ribbon-top-left::after {\n  bottom: 0;\n  left: 0;\n}\n.ribbon-top-left span {\n  right: -25px;\n  top: 30px;\n  transform: rotate(-45deg);\n}\n\n.chatButton {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    z-index: 99;\n}\n\n.roundedChatButton {\n  display:block;\n  height: 80px;\n  width: 80px;\n  border-radius: 50%;\n  background-color: #FFF;\n  border: 4px solid #004aad;\n  color: #000;\n  box-shadow: 5px 5px 10px 2px rgba(0,0,0,.8);\n}\n\n.roundedImage {\n  height: 60px;\n  width: 60px;\n  border-radius: 50%;\n  border: 3px solid gray;\n  padding: 5px;\n}\n\n.borderedSection {\n  border: 2px solid #EAEAEA;\n  padding: 20px;\n  border-radius: 10px;\n}\n\n.activeChat {\n  padding-left: 8px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  background-color: #004aad;\n  color: #FFF;\n  border-radius: 10px;\n\n}\n\n.activeChat:hover {\n  /* background-color: #EAEAEA; */\n  cursor: pointer;\n}\n\n.chatTextaArea {\n  position: absolute;\n  bottom: 10px;\n  width: 94%;\n}\n\n.textMessageArea {\n  border: 1px solid #000;\n  height: 50px;\n}\n\n.title {\n  color: #0E194F;\n  font-weight: 600;\n}\n\n.nursesList {\n  border: 2px solid #004aad;\n  border-radius: 10px;\n  padding: 5px;\n  margin: 10px\n}\n\n.nursesList:hover {\n  border: 2px solid #004aad;\n  background-color: #004aad;\n  color: #FFF;\n  transition: all .4s;\n}\n\n.pills {\n  background-color: #eae2b7;\n  color: #004aad;\n  border-radius: 25px;\n  padding: 10px 15px\n}\n\n.edit-pill {\n  appearance: none;\n  background-color: #0E194F;\n  border: 1px solid #FFF;\n  border-radius: 6px;\n  box-shadow: rgba(27, 31, 35, 0.04) 0 1px 0, rgba(255, 255, 255, 0.25) 0 1px 0 inset;\n  box-sizing: border-box;\n  color: #FFF;\n  cursor: pointer;\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  list-style: none;\n  padding: 6px 16px;\n  position: relative;\n  transition: background-color 0.2s cubic-bezier(0.3, 0, 0.5, 1);\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  vertical-align: middle;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-decoration: none !important;\n}\n\n\n.blue-pills {\n  background-color: #004aad;\n  color: #FFF;\n  border-radius: 15px;\n  padding: 0px 15px\n}\n\n.recent-readings-card {\n  border-radius: 10px;\n  padding: 10px;\n  max-height: 720px;\n  overflow-y: auto;\n}\n\n.shrinkText{\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.targetedMinutesCard{\n  max-height: 960px;\n  overflow-y: auto;\n}\n\n.colored-row {\n  background-color: #EAEAEA;\n  margin: 0;\n  padding: 10px;\n  border-radius: 10px;\n}\n\n.welcomeBack-background {\n  background-color: #EAE2B7;\n  border-radius: 15px; \n  padding: 40px; \n  margin: 0\n}\n\n.welcomeBack-heading {\n  color: #004aad;\n  font-weight: bold;\n}\n\n.w3-blue{\n  background-color:#004aad;\n  margin: 5px;\n  border-radius: 5px;\n}\n\n.coloredRow {\n  background-color: #EAE2B7;\n}\n\n.newSpan {\n  background-color: orange;\n  padding: 5px;\n  border-radius: 5px;\n  font-size: 10px;\n}\n\n/* New dropdowns */\n.dropdown-bg {\n  background-color: #FFF;\n  color: #004aad;\n  padding: 10px;\n  margin: 10px;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n  border-radius: 20px;\n}\n\n.dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n.dropdown-content {\n  display: none;\n  position: absolute;\n  background-color: #FFFFFF;\n  min-width: 160px;\n  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\n  padding: 12px 16px;\n  z-index: 1;\n  margin-top: 12px;\n  border-radius: 20px;\n}\n\n.dropdown:hover .dropdown-content {\n  display: block;\n}\n\n.roundedBorderImg {\n  border: 4px solid #219EBC;\n  padding: 4px;\n  border-radius: 50%;\n  background-color: #EAE2B7;\n}\n\n.reddishRow {\n  /* background-color: #F2BEBF */\n  background-color: #FBD9D3;\n\n}\n\n.rounded-btn {\n  border-radius: 50px;\n  padding: 18px;\n  margin-left: -30px !important;\n}\n\n.performanceCard {\n  background-color: #F8F9FF;\n  border: 4px solid white;\n  height: 270px;\n  border-radius: 15px;\n}\n\n.activePerformanceCard {\n  /* background-color: #FCCB06; */\n  background-color: gold;\n}\n\n.justPerformingCard {\n  background-color: #008000;\n  color: white !important;\n}\n\n.underPerformingCard{\n  background-color: #ff0000;\n  color: white !important;\n}\n\n.centeredImg {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n\n\n/* Tables size to their content; when wider than the page they scroll inside their own container. */\n.table-responsive { overflow-x: auto; max-width: 100%; }\ntable td, table th { overflow-wrap: normal; word-break: normal; }\ntable td.text-nowrap, table th.text-nowrap { white-space: nowrap; }\n\n/* Sidebar: long labels wrap inside their own row (rows grow) instead of spilling over the next item. */\n.sidebar .nav-links li { height: auto; min-height: 50px; }\n.sidebar .nav-links li a { height: auto; min-height: 50px; padding-right: 8px; }\n.sidebar .nav-links li a i { flex: 0 0 auto; }\n.sidebar .nav-links li a .link_name { flex: 1 1 auto; min-width: 0; white-space: normal; line-height: 1.25; overflow-wrap: anywhere; padding: 4px 0; }\n.sidebar .link-name-active { letter-spacing: normal; }\n\n/* Shared sortable table headers (components/SortableTable.js) */\n.sortable-th-btn { background: none; border: 0; padding: 0; margin: 0; font: inherit; color: inherit; font-weight: inherit; text-align: inherit; cursor: pointer; display: inline-flex; align-items: center; gap: 4px; white-space: nowrap; }\n.sortable-th-btn:focus-visible { outline: 2px solid #004aad; outline-offset: 2px; border-radius: 2px; }\n.sortable-th-btn .sort-arrow { font-size: 0.75em; opacity: 0.35; }\n.sortable-th-btn .sort-arrow-active { opacity: 1; }\n\n/* Vitals Portal branding: \"Powered by The Doctors Web\" + site footer */\n.vp-powered-by { font-size: 11px; color: #6c757d; letter-spacing: .3px; text-align: center; }\n.sidebar .vp-powered-by { color: #AEB6D6; margin: 0 0 10px; white-space: nowrap; }\n.sidebar.active .vp-powered-by { display: none; }\n.vp-site-footer { font-size: 12px; color: #8a8f98; text-align: center; padding: 10px 16px; }\nbody:has(.sidebar) .vp-site-footer { padding-left: 290px; }\nbody:has(.sidebar.active) .vp-site-footer { padding-left: 60px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
